export const esTranslations = {
  // Events POC — local demo account switcher
  demo: {
    title: "Modo demo",
    subtitle: "Cambie de cuenta con un clic para probar el POC de Eventos. Solo en local.",
    disabled: "El modo demo no está activado.",
    switching: "Cambiando de cuenta…",
    note: "Cuentas ficticias creadas por el script de demo de la API. Esta página no existe en producción.",
    personas: {
      visitor: {
        name: "Visitante",
        description: "Sin sesión: lo que ve quien escanea el código QR.",
      },
      attendee: {
        name: "Alice, participante",
        description: "Inscrita en los dos eventos de demo.",
      },
      orga: {
        name: "Olivia, organizadora",
        description: "Crea y gestiona los eventos.",
      },
      admin: {
        name: "Admin KeepTouch, superadministrador",
        description: "Valida a los organizadores y fija su comisión.",
      },
    },
    shortcuts: {
      title: "Accesos directos",
      qr: "Página de un evento desde el código QR (visitante)",
      ended: "Evento terminado, perfiles completos (Alice)",
      dashboard: "Espacio del organizador (Olivia)",
      create: "Crear un evento (Olivia)",
      admin: "Administración: solicitudes de organizadores (Admin KeepTouch)",
    },
  },
  errorBoundary: {
    title: 'Vaya, algo salió mal',
    message: 'Se produjo un problema inesperado. Puedes volver a intentarlo.',
  },
  api: {
    'ContactRequest.AlreadyExists': 'Ya has enviado una solicitud de contacto a este usuario',
    'Global.OperationNotAllowedError': 'No tienes permiso para realizar esta operación',
    'Global.ResourceDeletionNotAllowedError': 'No tienes permiso para eliminar este recurso',
    'Global.ResourceNotFoundError': 'El recurso no fue encontrado',
    'IdentityAndAccess.InvalidCredentialsError':
      'El correo electrónico o la contraseña es incorrecta',
    'IdentityAndAccess.EmailAlreadyTakenError': 'El correo electrónico ya está en uso',
    'Networking.CannotCancelNonPendingContactRequestError':
      'No puedes cancelar una solicitud de contacto que no está en estado PENDIENTE',
    'Networking.OnboardingAlreadyCompleteError': 'Ya has completado el proceso de incorporación',
    'Notifications.DeviceAlreadyRegisteredError': 'El dispositivo ya está registrado',
    'Networking.GhostProfileNoEmailError':
      'Este perfil no tiene dirección de correo. Añada un correo para enviar una invitación.',
    NetworkError: 'Error de red. Por favor, verifica tu conexión a internet.',
  },
  tabNavigation: {
    home: 'Inicio',
    contacts: 'Contactos',
    messages: 'Mensajes',
    notifications: 'Notificaciones',
    chatbot: 'Asistente IA',
    profile: 'Menú',
  },
  chatbot: {
    title: 'Asistente IA',
    placeholder: 'Pregúntame algo...',
    thinking: 'Pensando...',
    error: 'Ocurrió un error. Por favor, inténtalo de nuevo.',
    welcome:
      'Hola! Soy tu asistente IA. Puedo ayudarte a gestionar tus contactos, notas, categorías y hashtags. ¿Cómo puedo ayudarte?',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    actionConfirmed: 'Acción confirmada.',
    actionCancelled: 'Acción cancelada.',
    history: 'Historial',
    historyEmpty: 'Ninguna conversación guardada.',
    untitled: 'Conversación sin título',
    deleteConversationTitle: '¿Eliminar esta conversación?',
    deleteConversationError: 'No se pudo eliminar la conversación. Por favor, inténtalo de nuevo.',
    suggestionsTitle: 'Aquí tienes algunos ejemplos:',
    suggestions: {
      notes: 'Busca en todas mis notas',
      conversations: 'Resume mi última conversación de LinkedIn',
      sector: '¿Quién trabaja en ciberseguridad?',
      calendar: '¿Cuáles son mis próximas citas?',
      findContact: 'Ayúdame a encontrar un contacto',
    },
    actions: {
      createNote: 'Crear la nota «{name}»',
      updateNote: 'Modificar la nota {name}',
      deleteNote: 'Eliminar la nota {name}',
      createCategory: 'Crear la categoría «{name}»',
      createHashtag: 'Crear el hashtag «{name}»',
      createGhostProfile: 'Crear la ficha de {name}',
      updateGhostProfile: 'Modificar la ficha de {name}',
      deleteGhostProfile: 'Eliminar la ficha de {name}',
    },
  },
  welcome: {
    title: 'KEEPTOUCH',
    tagline: 'Un solo contacto puede cambiar toda una vida.',
    connection: 'Conexión',
    registration: 'Registro',
    slogan: 'Guarda, gestiona tus contactos del mañana \n Encuentra y realiza proyectos comunes',
    languageFr: 'Français',
    languageEn: 'English',
    languageEs: 'Español',
  },
  login: {
    title: 'Iniciar sesión',
    brand: 'KeepTouch',
    tagline: 'No pierdas el contacto con quienes importan',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    button: 'Iniciar sesión',
    noAccount: 'No tengo cuenta',
    or: 'O',
    error: {
      noInfo: 'Ingresa tu información',
      wrongCredentials: 'El correo electrónico o la contraseña es incorrecta',
      invalidEmail: 'Esta dirección de correo electrónico no es válida.',
    },
  },
  register: {
    title: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    button: 'Registrarse',
    haveAccount: 'Ya tengo una cuenta',
    or: 'O',
    error: {
      noInfo: 'Ingresa tu información',
      notSamePassword: 'Las contraseñas no coinciden',
    },
  },
  registerSteps: {
    step2: '¿Qué prefieres? #',
    step3: '¿El mejor momento para contactarte?',
    skip: 'Saltar',
  },
  registerStep1: {
    title: {
      picture: 'Añade tu foto de perfil:',
      gender: 'Eres:',
      name: 'Tu nombre:',
      surname: 'Tu apellido:',
      birthday: 'Tu fecha de nacimiento:',
      athletic: '¿Eres deportista?:',
      info: 'Sobre ti:',
      languages: '¿Qué idiomas hablas?:',
      nationality: '¿Cuál es tu nacionalidad?:',
      origin: '¿Cuál es tu origen?:',
      personality: '¿Cuál es tu personalidad?:',
      residence: '¿Dónde vives?:',
      smoker: '¿Fumas?:',
      conditions: 'Acepto las condiciones',
      conditionsRead: 'Leer:',
    },
    value: {
      women: 'Mujer',
      man: 'Hombre',
      nonBinary: 'No binario',
      other: 'Otro',
      yes: 'Sí',
      no: 'No',
      calm: 'Tranquilo',
      active: 'Activo',
      talkative: 'Hablador',
    },
    next: 'Siguiente',
  },
  registerStepHastags: {
    mainTitle: 'Lo que te define #',
    title: 'Qué hashtags te corresponden',
    placeholder: '#deporte',
    next: 'Siguiente',
  },
  registerStep3: {
    mainTitle: '¿El mejor momento para contactarte?',
    title: 'Selecciona los momentos en los que estás más disponible',
    aperitif: 'Aperitivo',
    breakfast: 'Desayuno',
    coffee: 'Café',
    dinner: 'Cena',
    lunch: 'Almuerzo',
    walk: 'Paseo',
    video_call: 'Videollamada',
    phone_call: 'Llamada',
    videoCall: 'Videollamada',
    phoneCall: 'Llamada',
    weekend: 'Fin de semana',
    sport: 'Deporte',
    event: 'Evento',
    next: 'Siguiente',
  },
  registerStep4: {
    aperitif: 'Aperitivo',
    breakfast: 'Desayuno',
    coffee: 'Café',
    dinner: 'Cena',
    lunch: 'Almuerzo',
    walk: 'Paseo',
    videoCall: 'Videollamada',
    phoneCall: 'Llamada',
    weekend: 'Fin de semana',
    sport: 'Deporte',
    event: 'Evento',
    next: 'Siguiente',
  },
  registerFinalStep: {
    congrats: 'Felicidades,\n{name} {surname},\n tu cuenta ha sido creada',
    congratsNoName: 'Felicidades,\ntu cuenta ha sido creada',
    next: 'Siguiente',
    geolocationText: 'Activa la geolocalización para una mejor experiencia de usuario',
  },
  forgotPassword: {
    title: 'Restablecer contraseña',
    email: 'Correo electrónico',
    emailConfirm: 'Confirmar correo electrónico',
    button: 'Enviar enlace por correo',
    success:
      'Si existe una cuenta con este correo, recibirás un enlace de restablecimiento en breve.',
    error: {
      noEmail: 'Por favor, ingresa tu correo electrónico.',
      generic: 'Algo salió mal. Por favor, inténtalo de nuevo más tarde.',
    },
  },
  contact: {
    title: 'Contactos',
    searchPlaceholder: 'Buscar un contacto',
    commonContacts: '{nbr} contactos{newline} en común',
    commonProjects: '{nbr} proyectos{newline} en común',
    addButton: 'Añadir',
    addTitle: 'Añadir {name} a tu perfil',
    commonTitleModal: 'Amigos y proyectos en común',
    filter: {
      search: 'Buscar',
      category: {
        location: 'Lugares',
        origin: 'Origen',
        role: 'Función',
        degree: 'Grado',
        hashtag: '#',
      },
      location: {
        continent: 'Continente',
        country: 'Buscar un país',
        region: 'Estados / Región',
      },
      nonLocation: {
        origin: 'Buscar un origen',
        role: 'Buscar una función',
        hashtag: 'Buscar por #',
      },
    },
    emptyReceivedRequest: 'No hay solicitudes recibidas por el momento',
    emptySentRequest: 'No hay solicitudes enviadas por el momento',
    emptyContactPro: 'No hay contactos profesionales',
    emptyContactPrivate: 'No hay contactos privados',
  },
  addContact: {
    title: 'Buscar un contacto',
    commonContacts: '{nbr} contactos{newline} en común',
    commonProjects: '{nbr} proyectos{newline} en común',
    addButton: 'Añadir',
    addTitle: 'Añadir {name} a tu perfil',
    commonTitleModal: 'Amigos y proyectos en común',
    filter: {
      search: 'Buscar',
      category: {
        location: 'Lugares',
        origin: 'Origen',
        role: 'Función',
        degree: 'Grado',
        hashtag: '#',
      },
      location: {
        continent: 'Continente',
        country: 'Buscar un país',
        region: 'Estados / Región',
      },
      nonLocation: {
        origin: 'Buscar un origen',
        role: 'Buscar una función',
        hashtag: 'Buscar por #',
      },
    },
    emptyData: 'No hay contactos sugeridos',
    degree1: '1.º',
    degree2: '2.º',
    degree3: '3.º',
  },
  requestContact: {
    received: 'Recibidas',
    sended: 'Enviadas',
  },
  menu: {
    profileButton: 'Ver perfil',
    nonExistentProfile: 'Perfil no existente',
    share: 'Compartir',
    settings: 'Ajustes',
    signOut: 'Cerrar sesión',
    version: 'Versión {version}',
  },
  contactType: {
    PRIVATE: 'Privado',
    PROFESSIONAL: 'Pro',
    GROUP: 'Grupo',
    OTHERS: 'Otros',
    GHOST: 'Fantasma',
  },
  profile: {
    premiumTitle: 'Probar Premium',
    mainMenus: {
      updateProfile: 'Editar perfil',
      shareProfile: 'Compartir perfil',
      calendar: 'Calendario',
      memories: 'Recuerdos',
    },
    hashtags: {
      blocTitle: 'Competencias',
      learn: {
        title: 'Aprender',
        placeholder: 'Buscar tus objetivos...',
      },
      target: {
        title: 'Objetivos',
        placeholder: 'Construir una casa...',
      },
      hobby: {
        title: 'Pasatiempos',
        placeholder: '# hacer karate...',
      },
      skill: {
        title: 'Competencias',
        placeholder: 'Marketing...',
      },
      button: 'Guardar',
    },
    contact: {
      email: {
        title: 'Correo electrónico',
      },
      phoneNumber: {
        title: 'Número de teléfono',
      },
      website: {
        title: 'Sitio web',
      },
      fbProfile: {
        title: 'Perfil de Facebook',
      },
      instagramProfile: {
        title: 'Perfil de Instagram',
      },
      linkedinProfile: {
        title: 'Perfil de LinkedIn',
      },
      twitterProfile: {
        title: 'Perfil de Twitter',
      },
      availability: 'Disponibilidad',
      contact: 'Contacto',
    },
    presentation: {
      title: 'Presentación',
    },
    question: {
      title: 'Pregunta',
      button: 'Guardar',
      nationalities: {
        title: '¿Cuáles son tus nacionalidades?:',
        placeholder: 'Buscar una nacionalidad...',
      },
      origins: {
        title: '¿Cuáles son tus orígenes?:',
        placeholder: 'Buscar un origen...',
      },
      languages: {
        title: '¿Qué idiomas hablas?:',
        placeholder: 'Buscar un idioma...',
        modal: {
          title: 'Seleccionar un país',
          search: {
            placeholder: 'Buscar un país...',
          },
        },
      },
      countries: {
        title: '¿Qué países has visitado?:',
        placeholder: 'Buscar un país...',
      },
      addLanguage: {
        title: 'Añadir un idioma',
        button: 'Guardar',
        language: {
          title: 'Idioma',
          placeholder: 'Seleccionar un idioma',
        },
        level: {
          title: 'Nivel',
          placeholder: 'Seleccionar tu nivel',
          beginner: 'Principiante',
          intermediate: 'Intermedio',
          advanced: 'Avanzado',
          expert: 'Experto',
        },
      },
    },
    livingPlaces: {
      title: 'Lugares de residencia',
      addLivingPlace: {
        title: 'Añadir un lugar de residencia',
        button: 'Guardar',
        country: {
          title: 'País',
          placeholder: 'Seleccionar un país',
        },
        from: {
          title: 'Desde',
        },
        to: {
          title: 'Hasta',
        },
      },
    },
    about: {
      title: 'Saber más',
      save: 'Guardar',
      categories: {
        learn: {
          title: '¿Qué quieres aprender?',
          placeholder: 'Buscar tus objetivos...',
        },
        objective: {
          title: 'Objetivo',
          placeholder: '#construir una casa...',
        },
        hobby: {
          title: 'Pasatiempo',
          placeholder: '# hacer karate...',
        },
        skills: {
          title: 'Competencias',
          placeholder: '# Marketing...',
        },
      },
    },
    updateSuccess: 'Perfil actualizado',
  },
  search: {
    placeholder: 'Buscar',
    noResults: 'Sin resultados',
  },
  imageUpload: {
    fromCamera: 'Tomar una foto',
    fromGallery: 'Importar desde el teléfono',
    cropTitle: 'Recortar la foto',
    cropHint: 'Arrastra la foto y ajusta su tamaño como quieras.',
    cropZoom: 'Tamaño',
    cropWhole: 'Foto entera',
    cropCancel: 'Cancelar',
    cropConfirm: 'Confirmar',
  },
  swipeable: {
    mute: 'Silenciar',
    pin: 'Fijar',
    unpin: 'Desfijar',
    delete: 'Eliminar',
  },
  errors: {
    "Events.OrganizerRequest.AlreadyOrganizer": "Ya eres organizador.",
    "Events.OrganizerRequest.AlreadyPending": "Ya tienes una solicitud pendiente de validación.",
    "Events.OrganizerRequest.AlreadyDecided": "Esta solicitud ya ha sido procesada.",
    "Events.OrganizerRequest.NotFound": "No se encuentra esta solicitud.",
    "Events.OrganizerInvitation.AccountExists": "Esta dirección ya tiene una cuenta de KeepTouch.",
    "Events.OrganizerInvitation.NotFound": "No se encuentra esta invitación (quizá ya se usó o se canceló).",
    "Events.Admin.InvalidPeriod": "Periodo no válido: la fecha de inicio debe ser anterior a la de fin.",
    "Events.Event.NotFound": "No se encuentra este evento. Compruebe el enlace.",
    "Events.Event.InvalidDates": "El evento debe terminar después de empezar.",
    "Events.Event.CapacityBelowAttendees": "No es posible: ya hay {attendeeCount} personas inscritas.",
    "Events.Organizer.Required": "Solo las cuentas de organizador pueden gestionar eventos.",
    "Events.Organizer.NotOwner": "Usted no es el organizador de este evento.",
    "Events.Connect.CannotAddSelf": "No puede añadirse a sí mismo.",
    "Events.Attendee.NotRegistered": "Inscríbase en el evento para ver a los participantes.",
    "Events.Registration.Closed": "Las inscripciones a este evento están cerradas.",
    "Events.Registration.Full": "Este evento está completo.",
    "Events.Price.OutOfRange": "El precio debe estar entre {minCents} y {maxCents} céntimos (0,50 € – 10 000 €).",
    "Events.Price.LockedByPayments": "El precio ya no puede cambiar (ni el evento pasar a gratuito): ya hay personas que han pagado.",
    "Events.Payment.EventIsFree": "Este evento es gratuito: no hay nada que pagar.",
    "Events.Payment.NotFound": "No se encuentra esta página de pago.",
    "Events.Payment.Expired": "La reserva ha caducado y la plaza ya no está disponible.",
    "Events.Payment.NotConfigured": "El pago no está disponible por ahora.",
    "Events.EmailCode.Invalid": "Código incorrecto o caducado. Pida uno nuevo.",
    "Events.EmailCode.TooManyRequests": "Demasiadas solicitudes. Inténtelo de nuevo en {retryAfterSeconds} segundos.",
    "Events.EmailCode.AccountNotFound": "Ninguna cuenta KeepTouch usa este correo.",
    "Events.Event.LocationRequired": "Indique el nombre del lugar del evento.",
    "Events.Event.OnlineUrlRequired": "Indique el enlace de la videoconferencia.",
    "Events.Event.InvalidRegistrationDeadline": "La fecha límite de inscripción debe estar en el futuro.",
    "Events.Event.AlreadyEnded": "Este evento ya ha terminado: elige una fecha de fin en el futuro.",
    "Events.Event.InvalidCoordinates": "Indica latitud y longitud, o ninguna de las dos.",
    "Events.Attendance.EventEnded": "El evento ha terminado: ya no puedes darte de baja.",
    "Events.CoverImage.Invalid": "Imagen rechazada: use un JPEG, PNG o WebP de 8 MB como máximo.",
    "Events.LinkedIn.SignInFailed": "La conexión con LinkedIn ha fallado. Inténtelo de nuevo o inscríbase sin LinkedIn.",
    "Events.LinkedIn.NotConfigured": "La conexión con LinkedIn aún no está disponible. Inscríbase sin LinkedIn.",
    "Events.Emailing.DailyLimitReached": "Límite diario alcanzado para este evento (máximo {limit} envíos por día). Vuelva a intentarlo mañana.",
    title: 'Se ha producido un problema',
    logError: 'Por favor, inicia sesión de nuevo',
    sessionExpired: 'Tu sesión ha caducado. Vuelve a iniciar sesión.',
    sessionCheckFailed: 'Conexión inestable: nuevo intento en un momento.',
    generic: 'Algo salió mal. Inténtalo de nuevo.',
    invalidEmail:
      'Esta dirección de correo parece incompleta o mal escrita (ejemplo: nombre@ejemplo.com).',
    tooManyRequests: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
    'Global.ResourceNotFoundError': 'Recurso no encontrado.',
    'Global.OperationNotAllowed': 'Operación no permitida.',
    'Global.PermissionDenied': 'No tienes permiso para realizar esta acción.',
    'Global.ResourceDeletionNotAllowed': 'Este recurso no puede ser eliminado.',
    'Identity.Authentication.Unauthenticated': 'Por favor inicia sesión de nuevo.',
    'Identity.SignIn.InvalidCredentials': 'Email o contraseña incorrectos.',
    'Identity.Authentication.PasswordNotSet': "Esta cuenta aún no tiene contraseña: inicie sesión con un código enviado por correo.",
    'Identity.DeleteAccount.PasswordRequired': "Para eliminar su cuenta, cree primero una contraseña (Ajustes): sirve para confirmar la eliminación.",
    'Identity.Password.AlreadySet': "Esta cuenta ya tiene contraseña. Use «Contraseña olvidada» para cambiarla.",
    'Identity.SignUp.EmailAlreadyTaken': 'Este email ya está en uso.',
    'Identity.ResetPassword.InvalidOrExpiredToken':
      'El enlace de restablecimiento es inválido o ha expirado.',
    'Networking.ContactRequest.SelfContactRequest':
      'No puedes enviarte una solicitud de contacto a ti mismo.',
    'Networking.ContactRequest.AlreadyExists':
      'Ya existe una solicitud de contacto con esta persona.',
    'Networking.ContactRequest.NotFound': 'Solicitud de contacto no encontrada.',
    'Keeptouch.ContactRequest.OnlyRecipientCanAnswer':
      'Solo la persona que recibió la solicitud puede responderla.',
    'Networking.Avatar.InvalidImage': 'Esta imagen no es válida.',
    'Networking.Note.SharedNoteRequiresContact':
      'Una nota compartida debe estar vinculada a un contacto.',
    'Networking.Note.CannotShareWithSelf': 'No puedes compartirte una nota a ti mismo.',
    'Networking.Note.CanOnlyShareWithContacts': 'Una nota solo se puede compartir con uno de tus contactos.',
    'Networking.Note.OnlyAuthorCanUpdate': 'Solo el autor de la nota puede modificarla.',
    'Networking.Note.OnlyCreatorOrContactCanUpdate':
      'Solo el creador o el contacto vinculado pueden modificar esta nota.',
    'Networking.Note.SharedNoteContactMustDifferFromAuthor':
      'El contacto de una nota compartida debe ser distinto del autor.',
    'Networking.KeepContact.OnlyCreatorCanUpdate':
      'Solo el creador puede modificar este recordatorio.',
    'Networking.KeepContact.ContactNotFound': 'Contacto no encontrado.',
    'Networking.KeepContact.ContactAlreadyHasFollowUp': 'Este contacto ya tiene un seguimiento.',
    'Networking.CalendarEvent.OnlyCreatorCanUpdate': 'Solo el creador puede modificar este evento.',
    'Networking.CalendarEvent.OnlyCreatorCanDelete': 'Solo el organizador puede eliminar esta cita.',
    'Networking.CalendarEvent.TitleRequired': 'Ponle un nombre a la cita.',
    'Networking.CalendarEvent.SomeParticipantsNotFound':
      'Algunos participantes no fueron encontrados.',
    'Networking.ScheduledMessage.RecipientOrGroupRequired':
      'Selecciona un destinatario o un grupo.',
    'Networking.ScheduledMessage.GroupNotFoundOrNotMember':
      'Grupo no encontrado o no eres miembro.',
    'Networking.ScheduledMessage.OnlyCreatorCanUpdate':
      'Solo el creador puede modificar este mensaje programado.',
    'Networking.ScheduledMessage.ContactNotFound': 'Contacto no encontrado.',
    'Networking.Group.NotFoundOrNotMember': 'Este grupo ya no existe, o no formas parte de él.',
    'Networking.Contact.NotFound': 'Esta persona no forma parte de tus contactos.',
    'Networking.UpdateContactScope.GhostNotAllowed':
      'El alcance solo puede cambiarse para contactos reales.',
    'Networking.Profile.OnlyOwnerCanUpdate': 'Solo el propietario puede modificar este perfil.',
    'Networking.Hashtag.OnlyCreatorCanUpdate': 'Solo el creador puede modificar este hashtag.',
    'Networking.Contact.ProfileNotFound': 'Perfil de contacto no encontrado.',
    'Networking.Contact.RelationshipNotFound': 'Relación de contacto no encontrada.',
    'Networking.GhostProfile.NotFound': 'Perfil fantasma no encontrado.',
    'Networking.GhostProfile.NoEmail':
      'Este perfil fantasma no tiene correo electrónico registrado.',
    'Networking.MergeContacts.GhostNotFoundOrNotOwned':
      'Perfil fantasma no encontrado o no te pertenece.',
    'Networking.MergeContacts.RealContactNotFound': 'Contacto real no encontrado en tus contactos.',
    'Networking.MergeGhostProfiles.SameProfile':
      'Un perfil fantasma no puede fusionarse consigo mismo.',
    'Networking.MergeGhostProfiles.GhostNotFoundOrNotOwned': 'Este perfil fantasma ya no existe.',
    'Networking.Profile.NotFoundOrNoRelationship':
      'Perfil no encontrado o sin relación de contacto.',
    'Networking.Conversation.NotFound': 'Conversación no encontrada.',
    'Ft.Chatbot.ConfirmFailed':
      'El asistente no pudo confirmar el resultado. Comprueba en tus notas o contactos si la acción se realizó antes de volver a intentarlo.',
    'Ft.Chatbot.ChatFailed': 'No se pudo procesar el mensaje del chatbot.',
    'Ft.VoiceNote.NoAudioFile': 'No se proporcionó archivo de audio.',
    'Ft.VoiceNote.ProcessingFailed': 'No se pudo procesar la nota de voz.',
    'Ft.ConversationAi.AnalyzeFailed': 'No se pudo analizar la conversación.',
    'Ft.ConversationAi.GenerateFailed': 'No se pudieron generar sugerencias.',
    'Ft.ConversationAi.SummarizeFailed': 'No se pudo resumir la conversación.',
    'Ft.BusinessCard.NoImageFile': 'No se proporcionó imagen.',
    'Ft.BusinessCard.ScanFailed': 'No se pudo escanear la tarjeta de visita.',
    'Ft.SocialImport.ImportNotFound': 'Importación no encontrada.',
    'Ft.SocialImport.ResultsNotReady': 'Los resultados de la importación aún no están disponibles.',
    'Ft.SocialImport.ResultsExpired': 'Los resultados de esta importación ya no están disponibles, vuelve a lanzarla.',
    'Ft.SocialImport.NetworkNotEnabled': 'La red "{network}" no está activada o configurada.',
    'Ft.SocialImport.UnsupportedNetwork': 'La red "{network}" no es compatible.',
    'Ft.SocialImport.NotInSucceededStatus': 'La importación no se completó con éxito.',
    'Ft.NearbyVisibility.UpdateFailed': 'No se pudo actualizar la visibilidad cercana.',
    'Ft.Translate.Failed': 'No se pudo traducir el texto.',
    'Notifications.DeviceAlreadyRegistered':
      'Este dispositivo ya está registrado para recibir notificaciones.',
    PLAN_LIMIT_CONTACTS_REACHED:
      'Has alcanzado el límite de {limit} contactos del plan gratuito. Hazte Keeptouch Infinity para tener contactos ilimitados.',
    PLAN_LIMIT_GHOST_PROFILES_REACHED:
      'Has alcanzado el límite de {limit} perfiles fantasma del plan gratuito. Hazte Keeptouch Infinity para tener perfiles fantasma ilimitados.',
    PLAN_LIMIT_NOTES_REACHED:
      'Has alcanzado el límite de {limit} notas del plan gratuito. Hazte Keeptouch Infinity para tener notas ilimitadas.',
    PLAN_LIMIT_REMINDERS_REACHED:
      'Has alcanzado el límite de {limit} recordatorios del plan gratuito. Hazte Keeptouch Infinity para tener recordatorios ilimitados.',
    PLAN_FEATURE_REMINDERS_DISABLED:
      'Los recordatorios son una función de Keeptouch Infinity. Hazte Keeptouch Infinity para no olvidar nunca mantener el contacto.',
    PLAN_FEATURE_EXPORT_DISABLED:
      'Exportar tus contactos es una función de Keeptouch Infinity. Hazte Keeptouch Infinity para llevarlos a todas partes.',
    PLAN_FEATURE_UNIPILE_DISABLED:
      'Conectar tus redes y tu calendario es una función de Keeptouch Infinity. Hazte Keeptouch Infinity para sincronizarlo todo.',
    PLAN_LIMIT_CARD_SCANS_REACHED:
      'El plan gratuito permite {limit} escaneos de tarjeta al mes. Hazte Keeptouch Infinity para escanear sin límite.',
    PLAN_FEATURE_CARD_SCAN_DISABLED:
      'El escaneo de tarjetas de visita es una función de Keeptouch Infinity.',
    AI_DAILY_LIMIT_REACHED:
      'Has alcanzado el límite de {limit} solicitudes a la IA cada 24 horas. Se renueva solo.',
    APIFY_DAILY_LIMIT_REACHED:
      'Has alcanzado el límite diario de importaciones y búsquedas de perfil ({limit} cada 24 horas). Se renueva solo.',
    APIFY_IMPORT_ALREADY_RUNNING:
      'Ya hay una importación de este perfil en curso. Espera a que termine.',
  },
  common: {
    today: 'Hoy',
    tomorrow: 'Mañana',
    statusOverdue: 'Pasado',
    statusUpcoming: 'Próximo',
    statusDone: 'Hecho',
    all: 'Todos',
    cancel: 'Cancelar',
    add: 'Añadir',
    save: 'Guardar',
    back: 'Volver',
    edit: 'Editar',
    delete: 'Eliminar',
    confirmDelete: 'Confirmar eliminación',
    choose: 'Elegir',
    validate: 'Validar',
    private: 'Privado',
    pro: 'Pro',
    group: 'Grupo',
    personCount: '{count, plural, one {# persona} other {# personas}}',
    resultsCount: '{count, plural, one {# resultado} other {# resultados}}',
    contactCount: '{count, plural, one {# contacto} other {# contactos}}',
    memberCount: '{count, plural, one {# miembro} other {# miembros}}',
    parenCount: ' ({count})',
    selectedCount: '{count} seleccionado(s)',
    shared: 'Compartido',
    personal: 'Personal',
    filter: 'Filtro',
    momentFilterAll: 'Todo',
    momentFilterToday: 'Hoy',
    momentFilterWeek: 'Esta semana',
    momentFilterMonth: 'Este mes',
    momentFilterLater: 'Más tarde',
    scanBusinessCard: 'Escanear una tarjeta de visita',
    inCommon: 'En común',
    viewMyProfile: 'Ver mi perfil',
    view: 'Ver',
    retry: 'Reintentar',
  },
  featureTooltip: {
    gotIt: 'Entendido',
    conversation_ai_panel: {
      description:
        'Sugerir: genera una respuesta. Resumir: vista general. Analizar: sentimiento y temas.',
    },
    scheduled_messages: {
      title: 'Mensajes programados',
      description:
        'Programa mensajes para enviar más tarde. La IA puede redactar el mensaje según el motivo (cumpleaños, saludo…). Desliza para editar o eliminar.',
    },
    scheduled_msg_reason: {
      title: 'Generación con IA',
      description:
        'Elige un motivo y añade detalles opcionales. La IA redactará un mensaje personalizado según el contexto y tu relación con el contacto.',
    },
    nearby_intro: {
      title: 'Contactos cercanos',
      description:
        'Descubre qué contactos están cerca de ti, en la misma ciudad o país. Tu ubicación se actualiza automáticamente una vez al día.',
    },
    keep_contact: {
      title: 'Recordatorios de contacto',
      description:
        'Crea recordatorios para no olvidar volver a escribir. Define fecha, recurrencia y filtra por categoría o hashtag. Los atrasados aparecen en rojo.',
    },
    graph_intro: {
      title: 'Grafo de relaciones',
      description:
        'Explora visualmente tus contactos y sus vínculos. Haz zoom, arrastra y toca un contacto para ver su perfil. Activa el modo Completo para ver enlaces por categoría, hashtag, ciudad…',
    },
    listing_contacts: {
      title: 'Tus contactos',
      description:
        'Filtra por Privado o Pro con las pestañas. Usa + para añadir un contacto manualmente, escanear una tarjeta o importar desde una red social.',
    },
    card_scanner: {
      title: 'Escáner de tarjetas',
      description:
        'Haz una foto o importa una tarjeta de visita. La IA extraerá los datos y creará un contacto nuevo.',
    },
    social_import: {
      title: 'Importar contactos sociales',
      description:
        'Elige una red e introduce un nombre de usuario. La IA importará seguidores o contactos de ese perfil a tu agenda.',
    },
    merge_intro: {
      title: 'Fusionar duplicados',
      description:
        'KeepTouch detecta las fichas que tienen el mismo nombre, email o teléfono que un contacto. Desliza a la derecha para fusionar (se te pide una confirmación antes de cada fusión), a la izquierda para ignorar. Toca un perfil para revisarlo antes de decidir.',
    },
    classify_swipe: {
      title: 'Clasifica tus contactos',
      description:
        'Desliza a la izquierda para Privado, a la derecha para Pro. También puedes usar los botones. Toca la tarjeta para abrir el perfil.',
    },
    chatbot_intro: {
      title: 'Asistente IA',
      description:
        'Pregunta por tus contactos, pide sugerencias o acciones como crear una nota o una ficha de contacto. La IA puede buscar, analizar y actuar por ti.',
    },
  },
  graphScreen: {
    title: 'Grafo de relaciones',
    nativeWebOnlyBody: 'La visualización del grafo está disponible en la versión web.',
    nativeWebOnlySubtext:
      'Inicia sesión en app.keeptouch.co desde un ordenador para explorar tus relaciones de forma interactiva.',
    loadingGraph: 'Cargando grafo…',
    mode: 'Modo',
    modeContacts: 'Contactos',
    modeFull: 'Completo',
    relations: 'Relaciones',
    statsLine: '{nodeCount} nodos · {edgeCount} enlaces',
    edgeContact: 'Contactos',
    edgeCategory: 'Categorías',
    edgeHashtag: 'Hashtags',
    edgeProfession: 'Profesiones',
    edgeNationality: 'Nacionalidades',
    edgeCity: 'Ciudades',
    legendMe: 'Yo',
    legendPrivate: 'Privado',
    legendPro: 'Pro',
    legendGhost: 'Fantasma',
    legendCategory: 'Categoría',
    legendHashtag: 'Hashtag',
    legendProfession: 'Profesión',
    legendNationality: 'Nacionalidad',
    legendCity: 'Ciudad',
    searchPlaceholder: 'Buscar en el grafo',
    loadError: 'Se produjo un error. Inténtalo de nuevo.',
  },
  geolocation: {
    unavailable: {
      title: 'Geolocalización no disponible',
      message: 'La geolocalización no está disponible en este dispositivo.',
    },
    denied: {
      title: 'Permiso denegado',
      message:
        'Necesitamos acceso a tu ubicación para ofrecerte una mejor experiencia. ¿Deseas abrir los ajustes para activar la geolocalización?',
      cancel: 'Cancelar',
      settings: 'Ajustes',
    },
    blocked: {
      title: 'Permiso bloqueado',
      message:
        'El acceso a la geolocalización ha sido bloqueado. Por favor, ve a los ajustes de la aplicación para activarlo manualmente.',
      cancel: 'Cancelar',
      settings: 'Ajustes',
    },
  },
  contacts: {
    searchProfile: 'Buscar un perfil',
    addNonExistingProfile: 'Añadir un perfil no existente',
    importFromContacts: 'Importar desde mis contactos',
    importFrom: 'Importar desde {network}',
    uncontact: 'Eliminar de mis contactos',
    uncontactConfirmTitle: 'este contacto',
  },
  settings: {
    notifications: 'Notificaciones',
    notificationsDescription: 'Elige cuándo te avisa tu móvil.',
    title: 'Ajustes',
    language: 'Idioma',
    languageDescription: 'Elige el idioma de la aplicación',
    auto: 'Automático (idioma del dispositivo)',
    french: 'Francés',
    english: 'Inglés',
    spanish: 'Español',
    location: 'Ubicación',
    locationDescription: 'El permiso de este dispositivo y quién ve tu posición',
    locationPermission: 'Permiso de este dispositivo',
    locationPermissionGranted: 'Concedido',
    locationPermissionDenied: 'Denegado',
    locationPermissionUndetermined: 'Aún no solicitado',
    locationPermissionUnknown: 'No se puede comprobar',
    locationAllow: 'Permitir',
    locationVisibility: 'Quién ve mi posición',
    locationDenied: 'Ubicación bloqueada por el navegador. Permítela para este sitio.',
    locationDeniedApp: 'Ubicación denegada. Permítela en los ajustes del teléfono.',
    openPhoneSettings: 'Ajustes del teléfono',
    subscription: 'Suscripción',
    subscriptionDescription: 'Tu plan actual de KeepTouch',
    legal: 'Información legal',
    legalDescription: 'Aviso legal, privacidad y contacto.',
    subscriptionFree: 'Plan gratuito',
    subscriptionManage: 'Ver planes Premium',
    subscriptionPremium: 'Premium activo',
    calendarSync: 'Sincronización de calendario',
    calendarSyncDescription: 'Añade tus eventos de KeepTouch a tu calendario.',
    calendarSyncEnable: 'Sincronizar con mi calendario',
    calendarSyncPermissionDenied: 'Se necesita permiso de calendario para sincronizar.',
    deleteAccountTitle: 'Eliminar mi cuenta',
    deleteAccountDescription:
      'Elimina permanentemente tu cuenta y todos tus datos. Esta acción no se puede deshacer.',
    deleteAccountButton: 'Eliminar mi cuenta',
    deleteAccountConfirmTitle: '¿Eliminar tu cuenta?',
    deleteAccountConfirmMessage:
      'Esto es permanente: tu cuenta y todos tus datos (contactos, notas, mensajes…) se eliminarán. No podrás recuperarlos.',
    deleteAccountCancel: 'Cancelar',
    deleteAccountConfirm: 'Eliminar permanentemente',
    deleteAccountInProgress: 'Eliminando…',
    deleteAccountPasswordPlaceholder: 'Introduce tu contraseña',
    deleteAccountWrongPassword: 'Contraseña incorrecta.',
    deleteAccountError: 'No se pudo eliminar la cuenta. Inténtalo de nuevo.',
    deleteAccountNeedPassword: 'Para eliminar su cuenta, cree primero una contraseña: sirve para confirmar la eliminación.',
    deleteAccountCreatePassword: 'Crear una contraseña',
  },
  calendarModal: {
    month0: 'Enero',
    month1: 'Febrero',
    month2: 'Marzo',
    month3: 'Abril',
    month4: 'Mayo',
    month5: 'Junio',
    month6: 'Julio',
    month7: 'Agosto',
    month8: 'Septiembre',
    month9: 'Octubre',
    month10: 'Noviembre',
    month11: 'Diciembre',
    weekDay0: 'LUN',
    weekDay1: 'MAR',
    weekDay2: 'MIÉ',
    weekDay3: 'JUE',
    weekDay4: 'VIE',
    weekDay5: 'SÁB',
    weekDay6: 'DOM',
    time: 'Hora',
    schedule: 'Programar',
    subscriptionManage: 'Ver planes Premium',
    subscriptionPremium: 'Premium activo',
  },
  connectedServices: {
    sectionTitle: 'Servicios conectados',
    sectionDescription:
      'Conecta tus mensajerías para importar automáticamente tus contactos a KeepTouch.',
    connect: 'Conectar',
    connected: 'Conectado',
    reconnect: 'Reconectar',
    statusConnecting: 'Conectando…',
    wizardOpened: 'Termina la conexión en la pestaña que se acaba de abrir y vuelve aquí.',
    disconnect: 'Desconectar',
    disconnected: 'Servicio desconectado.',
    disconnectError: 'La desconexión falló, inténtalo de nuevo.',
    wizardError: 'No se pudo crear el enlace de conexión, inténtalo de nuevo.',
    refresh: 'Actualizar',
    filterPlaceholder: 'Filtro (opcional): p. ej. ciberseguridad, finanzas…',
    syncFilteredOut: '{filtered} contacto(s) fuera del filtro no importados',
    syncTruncated: 'Solo se han leído los 500 primeros contactos de este servicio.',
    syncStarted: 'Importación iniciada — puede tardar unos minutos. ¡No hace falta desconectar el servicio! ⏳',
    syncInProgressHint: 'Importación en curso… Puede tardar unos minutos, puedes seguir usando la aplicación.',
    syncNow: 'Importar mis contactos',
    syncing: 'Importando…',
    syncResult: '{created} contacto(s) importado(s), {skipped} ya presentes',
    syncEmpty: 'No hay contactos nuevos para importar',
    syncError: 'La importación falló, inténtalo de nuevo.',
    planLimit: 'Límite del plan gratuito alcanzado — algunos contactos no se importaron.',
    noAccounts: 'Ningún servicio conectado por ahora.',
    serviceInstagram: 'Instagram',
    serviceWhatsapp: 'WhatsApp',
    serviceLinkedin: 'LinkedIn',
    serviceGmail: 'Gmail',
    calendarSync: 'Sincronizar Google Calendar',
    calendarSyncing: 'Sincronizando…',
    calendarConnect: 'Conectar Google Calendar',
    calendarSyncResult: '{created} evento(s) importado(s), {skipped} ya presentes',
    calendarSyncEmpty: 'Calendario ya al día',
    calendarSyncError: 'La sincronización falló, inténtalo de nuevo.',
  },
  subscription: {
    title: 'Suscripción',
    headline: 'Elige tu experiencia Keeptouch',
    intro: 'Dos planes para hacer crecer y cuidar tu red humana, a tu ritmo.',
    // Versión Gratuita
    freeTierTitle: 'Versión Gratuita',
    freeTierSubtitle: 'Para descubrir Keeptouch y organizar tus primeros contactos.',
    freePriceLabel: 'Gratis',
    freeFeatureContacts: 'Hasta {count} contactos',
    freeFeatureGhosts: '{count} perfiles fantasma',
    freeFeatureNotes: '{count} notas personales',
    freeFeatureReminders: '{count} recordatorios de seguimiento',
    // Keeptouch Infinity
    infinityTierTitle: 'Keeptouch Infinity',
    infinityTierSubtitle: 'La experiencia completa para los constructores de red humana.',
    infinityBadge: 'Recomendado',
    infinityPriceFallback: '6,99 €/mes',
    infinityPricePerMonth: '{price}/mes',
    infinityFeatureContacts: 'Contactos y perfiles fantasma ilimitados',
    infinityFeatureNotes: 'Notas personales ilimitadas',
    infinityFeatureReminders: 'Recordatorios de seguimiento ilimitados',
    infinityFeatureIntegrations: 'Conexión de tus redes y tu agenda',
    infinityFeatureExport: 'Exportación de tus contactos (.vcf)',
    infinityCta: 'Iniciar Keeptouch Infinity',
    comingSoon: 'Muy pronto',
    comingSoonMessage: 'Keeptouch Infinity llega muy pronto. ¡Gracias por tu paciencia!',
    premiumTitle: 'Eres Infinity',
    premiumSubtitle: 'Gracias por formar parte de Keeptouch Infinity. Disfrutas de todas las funciones, sin límite.',
    premiumActive: 'Suscripción activa',
    expiresOn: 'Se renueva el {date}',
    endsOn: 'Tu suscripción termina el {date}',
    offeredUntil: 'Acceso ofrecido hasta el {date}',
    currentPeriodUntil: 'Periodo actual hasta el {date}',
    processing: 'Procesando…',
    activating: 'Activando tu suscripción…',
    activationPendingTitle: 'Pago recibido',
    activationPendingMessage:
      'La activación puede tardar unos minutos. Esta página se actualizará sola.',
    purchaseSuccessTitle: 'Bienvenido a Keeptouch Infinity',
    purchaseSuccessMessage: 'Tu suscripción está activa. ¡Disfruta de todas las funciones!',
    purchaseErrorTitle: 'No se pudo completar la compra',
    purchaseErrorMessage: 'La compra no se pudo completar. Inténtalo de nuevo.',
    restoreCta: 'Restaurar compras',
    restoring: 'Restaurando…',
    restoreSuccessTitle: 'Suscripción restaurada',
    restoreSuccessMessage: 'Tu suscripción Infinity se ha restaurado.',
    restoreNoneTitle: 'Nada que restaurar',
    restoreNoneMessage: 'No encontramos ninguna suscripción activa en esta cuenta.',
    restoreErrorTitle: 'No se pudo restaurar',
    restoreErrorMessage: 'La restauración no se pudo completar. Inténtalo de nuevo.',
    manageCta: 'Gestionar mi suscripción',
    manageErrorTitle: 'No se pudo abrir',
    manageErrorMessage: 'No se pudo abrir la página de gestión de la suscripción.',
    cancelCta: 'Cancelar mi suscripción',
    cancelConfirmQuestion: '¿Seguro que quieres cancelar tu suscripción?',
    cancelConfirmUntilDate:
      'Conservarás todas las funciones de Keeptouch Infinity hasta el {date} y después tu cuenta volverá a la versión gratuita.',
    cancelConfirmUntilPeriodEnd:
      'Conservarás todas las funciones de Keeptouch Infinity hasta el final del periodo ya pagado y después tu cuenta volverá a la versión gratuita.',
    cancelConfirmYes: 'Sí, cancelar mi suscripción',
    cancelConfirmNo: 'No, mantener mi suscripción',
    cancelOfferedTitle: 'Suscripción ofrecida',
    cancelOfferedMessage:
      'Tu acceso a Keeptouch Infinity te fue ofrecido: no hay ningún pago en curso, así que no hay nada que cancelar.',
    cancelUnavailableTitle: 'No se puede cancelar por ahora',
    cancelUnavailableMessage:
      'No pudimos abrir la página para cancelar tu suscripción. Inténtalo de nuevo en unos instantes.',
    legalDisclosure:
      'Suscripción mensual de renovación automática de 6,99 €/mes. Se renueva automáticamente salvo cancelación al menos 24 h antes del fin del periodo. Puedes cancelar en cualquier momento en los ajustes de tu cuenta.',
    termsOfUse: 'Términos de uso',
    privacyPolicy: 'Política de privacidad',
  },
  planLimit: {
    title: 'Hazte Keeptouch Infinity',
    body: 'Has alcanzado un límite del plan gratuito. Hazte Keeptouch Infinity para desbloquear esta función.',
    upgrade: 'Hazte Keeptouch Infinity',
    later: 'Quizás más tarde',
    close: 'Cerrar',
    noCommitment: 'Sin compromiso',
    cancelAnytime: 'Cancela cuando quieras',
    included: 'Qué incluye',
  },
  export: {
    sectionTitle: 'Exportar mis contactos',
    sectionDescription:
      'Descarga todos tus contactos en formato vCard (.vcf), importable en cualquier agenda.',
    cta: 'Exportar mis contactos (.vcf)',
    exporting: 'Exportando…',
    successTitle: 'Exportación completada',
    successMessage: 'Tus contactos se exportaron en formato vCard.',
    emptyTitle: 'Ningún contacto para exportar',
    emptyMessage: 'Añade contactos y vuelve a lanzar la exportación.',
  },
  eventsExport: {
    sectionTitle: 'Mis datos de eventos',
    sectionDescription:
      'Descarga gratis tus inscripciones, tu asistencia, tus pagos, las invitaciones recibidas, los contactos añadidos desde un evento y tus solicitudes de organizador.',
    ctaJson: 'Exportar (JSON)',
    ctaCsv: 'Exportar (hoja de cálculo CSV)',
    exporting: 'Exportando…',
    successTitle: 'Exportación completada',
    successMessage: 'Tus datos de eventos se exportaron.',
  },
  recurrence: {
    title: 'Recurrencia',
    custom: 'Personalizada',
    recurrence: 'Recurrencia',
    every: 'Cada',
    everyDay: 'Cada día',
    everyWeek: 'Cada semana',
    every2Weeks: 'Cada 2 semanas',
    every6Weeks: 'Cada 6 semanas',
    everyMonth: 'Cada mes',
    every3Months: 'Cada 3 meses',
    every6Months: 'Cada 6 meses',
    everyYear: 'Cada año',
    repeatOn: 'Repetir el',
    end: 'Fin',
    never: 'Nunca',
    on: 'El',
    after: 'Después de',
    lastDayOfMonth: 'Último día del mes',
    day: 'día',
    week: 'semana',
    month: 'mes',
    year: 'año',
    repetition: 'repetición',
  },
  calendarEvent: {
    createEvent: 'Crear una cita',
    editEvent: 'Modificar la cita',
    shared: 'Compartido',
    sharedCount: '{count, plural, one {Compartido} other {Compartidos}}',
    personal: 'Personal',
    eventName: 'Nombre de la cita',
    eventNamePlaceholder: 'Nombre de la cita...',
    addGuests: 'Añadir invitados',
    searchGuests: 'Buscar invitados...',
    addPeoplePrivate: 'Personas implicadas',
    searchPeoplePrivate: 'Buscar una persona...',
    privatePeopleHint: 'No reciben aviso y no ven esta cita.',
    eventDate: 'Fecha del evento',
    allDay: 'Todo el día',
    addLocation: 'Añadir un lugar',
    locationTitle: 'Lugar',
    description: 'Descripción',
    descriptionPlaceholder: 'Descripción...',
    alert: 'Alerta',
    alertEnabled: 'Alerta activada',
    noAlert: 'Sin alerta',
    inviteAndAdd: 'Invitar y añadir a KeepTouch',
    addToCalendar: 'Añadir solo a KeepTouch',
    addToGoogle: 'Añadir a Google Calendar',
    deleteConfirm: '¿Eliminar esta cita?',
    markAsDone: 'Marcar como hecho',
    markAsNotDone: 'Marcar como no hecho',
    birthdayOn: 'Cumpleaños: {date}',
    keepContactPlannedOn: 'Mantener contacto: recordatorio el {date}',
    titleRequired: 'Ponle un nombre a la cita.',
    endBeforeStart: 'La cita termina antes de empezar.',
  },
  ghostProfile: {
    inviteToJoin: 'Invitar a unirse',
    inviteSent: 'Invitación enviada por correo electrónico.',
    inviteAgain: 'Volver a invitar',
    inviteConfirmTitle: '¿Invitar a {name}?',
    inviteConfirmBody:
      'Se enviará un correo de invitación a {email}, con un enlace para crear una cuenta y encontrarte en KeepTouch.',
    inviteConfirmAgain:
      'Ya invitaste a {name} el {date}. ¿Volver a enviar la invitación a {email}?',
    inviteSend: 'Enviar',
    inviteError: 'No se pudo enviar la invitación. Por favor, inténtelo de nuevo.',
    inviteErrorNoEmail:
      'Este perfil no tiene dirección de correo. Añada un correo para enviar una invitación.',
    editProfile: 'Editar perfil',
    about: 'Acerca de',
    presentation: 'Presentación',
    birthday: 'Cumpleaños',
    languages: 'Idiomas',
    nationalities: 'Nacionalidades',
    origins: 'Orígenes',
    contactInfo: 'Datos de contacto',
    email: 'Correo',
    phone: 'Teléfono',
    website: 'Sitio web',
    availabilities: 'Disponibilidad',
    livedPlaces: 'Lugares de residencia',
    categories: 'Categorías',
    searchCategories: 'Buscar categorías',
    keepContact: 'Mantener contacto',
    context: 'Contexto',
    hashtag: 'Hashtag',
    searchHashtags: 'Buscar hashtags',
    hashtags: 'Hashtags',
    objectives: 'Objetivos',
    hobby: 'Hobby',
    skills: 'Competencias',
    notes: 'Notas',
    appointments: 'Citas / Recordatorios',
    memories: 'Recuerdos',
    shareProfile: 'Compartir',
    message: 'Mensaje',
    requestSent: 'Solicitud enviada',
    openOnKeepTouch: 'Abrir en KeepTouch',
    edit: 'Editar',
    deleteProfile: 'Eliminar este perfil',
    deleteConfirmTitle: 'este perfil fantasma',
    deleteConfirmMessage:
      '¿Eliminar este perfil fantasma? Las notas y los seguimientos vinculados a esta persona se eliminarán definitivamente con él. Esta acción es irreversible.',
    deleteSuccess: 'Perfil fantasma eliminado',
    updateSuccess: 'Perfil fantasma actualizado',
    createSuccess: 'Perfil fantasma creado',
    noInteractionYet: 'No hay interacción todavía',
    lastInteraction: 'Última interacción {time}',
    viewMyProfile: 'Ver mi perfil',
    aboutProfile: 'Acerca del perfil',
    pins: 'Anclados',
    strangerNotice: 'Añade a {name} a tus contactos para ver el resto de su perfil.',
    strangerNoticePending:
      'El resto del perfil de {name} se mostrará cuando se acepte tu solicitud.',
    strangerNoticeReceived:
      '{name} quiere añadirte a sus contactos. Acepta su solicitud para ver el resto de su perfil.',
    cancelRequest: 'Cancelar la solicitud',
    cancelRequestHeading: 'Cancelar la solicitud',
    cancelRequestTitle: '¿Cancelar la solicitud enviada a {name}?',
    notFoundTitle: 'Perfil no encontrado',
    notFoundMessage:
      'Este enlace o código QR no corresponde a ningún perfil. Puede que sea antiguo o que la cuenta se haya eliminado.',
    loadErrorTitle: 'No se puede cargar este perfil',
    loadErrorMessage: 'Comprueba tu conexión e inténtalo de nuevo.',
  },
  contextes: {
    title: 'Contextos',
    meetingContext: 'Marco del encuentro',
    associatedEmotion: 'Emoción asociada',
    relationshipEvolution: 'Evolución de la relación',
    relationshipAutomatic: 'Calculada automáticamente a partir de tus mensajes',
    associatedColor: 'Color asociado',
    referencePlace: 'Lugar de referencia',
    enterPlace: 'Ingresa un lugar',
    chooseMeetingContext: 'Elegir el marco del encuentro',
    editMeetingContext: 'Modificar el marco del encuentro',
    chooseEmotion: 'Elegir la emoción asociada',
    editEmotion: 'Modificar la emoción asociada',
    chooseRelationship: 'Elegir la evolución de la relación',
    editRelationship: 'Modificar la evolución de la relación',
    chooseColor: 'Elegir el color asociado',
    editColor: 'Modificar el color asociado',
    searchMeetingContext: 'Buscar un marco de encuentro',
    searchEmotion: 'Buscar una emoción asociada',
    searchRelationship: 'Buscar una evolución de la relación',
    searchColor: 'Buscar un color asociado',
    save: 'Guardar',
    unsavedTitle: 'Cambios sin guardar',
    unsavedMessage: '¿Seguro que no quieres guardar?',
    leaveWithoutSaving: 'Salir sin guardar',
    keepEditing: 'Cancelar',
  },
  categories: {
    notFound: 'Categoría no encontrada',
    gallery: 'Galería',
    camera: 'Cámara',
    person: 'persona',
    persons: 'personas',
  },
  importContacts: {
    back: 'Volver',
    importCard: 'Importar una tarjeta de visita',
    businessCard: 'Tarjeta de visita',
    dragCard: 'Arrastra la tarjeta de visita aquí',
    or: 'O',
    selectFiles: 'Seleccionar de tus archivos',
    supportedFormats: 'Formatos admitidos: PDF, JPEG, PNG',
    startImport: 'Iniciar la importación',
    contactFound: 'Contacto encontrado en KeepTouch',
    profileFound: '¡Perfil encontrado!',
    addNewContact: 'Añadir un nuevo contacto:',
    validate: 'Validar y guardar la ficha',
    validating: 'Guardando…',
    checkInfo: 'Verificar la información importada',
    alreadySaved: 'Este contacto ya está en tu lista. «Validar» guarda tus correcciones.',
    discard: 'No conservar este contacto',
    firstName: 'Nombre',
    enterFirstName: 'Ingresa el nombre',
    lastName: 'Apellido',
    enterLastName: 'Ingresa el apellido',
    profession: 'Profesión',
    enterProfession: 'Ingresa la profesión',
    company: 'Empresa',
    enterCompany: 'Ingresa la empresa',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    website: 'Sitio web',
    hashtag: 'Hashtag',
    hashtagPlaceholder: 'Nombre del #...',
    categoriesLabel: 'Categorías',
    searchProfession: 'Buscar una profesión',
    file: {
      title: 'Importar desde un archivo CSV',
      subtitle:
        'Suelta una exportación CSV de tu CRM o de Google Contacts: compruebas las columnas y se crea un perfil fantasma para cada contacto que aún no está entre los tuyos.',
      drag: 'Arrastra tu archivo aquí',
      formats: 'Formato admitido: CSV (.csv)',
      fullName: 'Nombre completo',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'Twitter / X',
      notes: 'Notas',
      unsupportedFormat: 'Formato no admitido. Elige un archivo CSV (.csv). Exporta primero los archivos Excel a CSV.',
      empty: 'El archivo no contiene ninguna fila de contacto.',
      parseError: 'No se pudo leer el archivo. Comprueba que sea un CSV válido.',
      detected: '{count} contacto(s) detectado(s) en el archivo',
      columnsDetected: 'Comprueba las columnas antes de importar:',
      columnsTitle: 'Columnas del archivo',
      ignoreColumn: 'Ignorar',
      sample: 'Ejemplo: {value}',
      previewTitle: 'Vista previa',
      noUsableRows: 'No hay filas utilizables: se necesita al menos un nombre, email o teléfono.',
      importButton: 'Importar {count} contacto(s)',
      importing: 'Creando perfiles… {done} / {total}',
      doneTitle: '{count} contacto(s) importado(s) con éxito',
      doneDuplicates: '{count} ya en tus contactos, no importado(s) de nuevo',
      doneIgnored: '{count} fila(s) omitida(s): sin nombre, email ni teléfono',
      doneFailed: '{count} contacto(s) rechazado(s):',
      doneLimit: 'Límite de tu plan alcanzado: {count} contacto(s) no importado(s)',
      failureLine: 'Contacto n.º {row} — {name}: {reason}',
      moreFailures: 'y {count} más',
      importAnother: 'Importar otro archivo',
      importedToast: '{count} perfil(es) fantasma creado(s)',
    },
  },
  contactsList: {
    noContactFound: 'Ningún contacto encontrado',
    contactViaSocial: 'Contactar por redes sociales',
  },
  socialNetwork: {
    contactViaLinkedin: 'Contactar por LinkedIn',
    contactViaFacebook: 'Contactar por Facebook',
    contactViaInstagram: 'Contactar por Instagram',
    contactViaTwitter: 'Contactar por Twitter',
  },
  keepContact: {
    editReminder: 'Editar seguimiento',
    createReminder: 'Crear un seguimiento',
    reminderTitle: 'Título del seguimiento',
    reminderTitlePlaceholder: 'Nombre del seguimiento...',
    description: 'Descripción',
    descriptionPlaceholder: 'Descripción...',
    addContact: 'Añadir un contacto',
    searchContact: 'Buscar un contacto...',
    contactLabel: 'Contacto',
    eventDate: 'Fecha del evento',
    addLocation: 'Añadir un lugar',
    location: 'Lugar',
    alert: 'Alerta',
    alertEnabled: 'Alerta activada',
    noAlert: 'Sin alerta',
    alertActive: 'Activa',
    alertInactive: 'Inactiva',
    backToProfile: 'Volver al perfil',
    pageTitle: 'Mantener contacto',
    reminder: 'seguimiento',
    reminders: 'seguimientos',
    statusLate: 'Atrasado',
    deleteConfirm: 'este seguimiento',
    filter: 'Filtro',
    none: 'Ninguna',
    keepContactWith: 'Mantener contacto con {contactName}',
    listView: 'Lista',
    boardView: 'Tablero',
  },
  resetPassword: {
    title: 'Definir nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    button: 'Restablecer contraseña',
    success: 'Tu contraseña ha sido restablecida. Ya puedes iniciar sesión.',
    error: {
      noToken: 'Enlace de restablecimiento inválido o faltante. Por favor, solicita uno nuevo.',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      generic: 'El enlace puede haber expirado. Por favor, solicita uno nuevo.',
    },
  },
  photoAlert: {
    title: 'Elegir una foto',
    message: 'Selecciona una opción',
  },
  qrCode: {
    shareMessage: 'Descubre mi perfil KeepTouch: {url}',
    shareTitle: 'Mi perfil KeepTouch',
    error: 'Error',
    shareError: 'No se pudo compartir el perfil',
    success: 'Éxito',
    linkCopied: 'Enlace copiado al portapapeles',
    copyError: 'No se pudo copiar el enlace',
    info: 'Información',
    downloadTodo: 'Función de descarga por implementar',
    downloaded: 'Código QR descargado',
    downloadError: 'No se pudo descargar el código QR',
    notKeepTouchUrl: 'Este código QR no contiene un enlace a un perfil KeepTouch.',
    scanTitle: 'Escanear código QR',
    scanInstruction: 'Apunta tu cámara hacia un código QR de KeepTouch para escanearlo.',
    scanWebFallbackActive: 'Usando escáner alternativo para tu navegador.',
    cameraPermissionTitle: 'Acceso a la cámara requerido',
    cameraPermissionMessage:
      'Por favor, permite el acceso a la cámara en la configuración de tu navegador para escanear códigos QR.',
    cameraPermissionMessageApp: 'Permite que KeepTouch use la cámara para escanear un código QR.',
    allowCamera: 'Permitir la cámara',
    openSettings: 'Abrir los ajustes',
  },
  webNav: {
    search: 'Buscar',
    allContacts: 'Todos mis contactos',
    messaging: 'Mensajería',
    notifications: 'Notificaciones',
    myProfile: 'Mi perfil',
    signOut: 'Cerrar sesión',
    settings: 'Ajustes',
  },
  menuItems: {
    admin: "Administración",
    events: "Eventos",
    importContacts: 'Importar contactos',
    classifyProfiles: 'Clasificar perfiles',
    mergeProfiles: 'Fusionar perfiles',
    maps: 'Mapas',
    notes: 'Notas',
    categories: 'Categorías',
    hashtags: 'Hashtags',
    relationalColors: 'Colores relacionales',
    appointments: 'Citas / Recordatorios',
    birthdays: 'Cumpleaños',
    keepContact: 'Mantener contacto',
    scheduledMessages: 'Mensajes programados',
    qrCode: 'Código QR',
    settings: 'Ajustes',
    graph: 'Gráfico relacional',
    nearby: 'Contactos cercanos',
  },
  form: {
    contactInfo: 'Info de contacto',
    about: 'Acerca de',
    woman: 'Mujer',
    man: 'Hombre',
    mainInfo: 'Información principal',
    firstName: 'Nombre',
    enterFirstName: 'Ingresa el nombre',
    lastName: 'Apellido',
    enterLastName: 'Ingresa el apellido',
    professions: 'Profesión(es)',
    enterProfession: 'Ingresa la profesión',
    company: 'Empresa',
    enterCompany: 'Nombre de la empresa (opcional)',
    email: 'Correo electrónico',
    phoneNumber: 'Número de teléfono',
    socialNetworks: 'Redes sociales',
    website: 'Sitio web',
    descriptionPlaceholder: 'Descripción...',
    presentation: 'Presentación',
    birthDate: 'Fecha de nacimiento',
    livingPlace: 'Lugar de residencia',
    origins: 'Orígenes',
    nationalities: 'Nacionalidades',
    nationalityPlaceholder: 'Nacionalidad',
    spokenLanguages: 'Idiomas hablados',
    enterLanguages: 'Ingresa los idiomas',
    livedPlaces: 'Lugares vividos',
    hashtags: 'Hashtags',
    availabilityAndMeetings: 'Disponibilidad y tipos de encuentros',
    availability: 'Disponibilidad',
    bestMoment: 'Mejor momento',
    bestMoments: 'Mejores momentos',
    chooseDay: 'Elegir un día',
    chooseTime: 'Elegir una hora',
    days: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
    },
    searchLanguage: 'Buscar un idioma',
    searchPlace: 'Buscar un lugar',
    searchNationality: 'Buscar una nacionalidad',
    searchHashtags: 'Buscar hashtags',
    searchCategories: 'Buscar categorías',
    searchProfession: 'Buscar una profesión',
    backToProfile: 'Volver al perfil',
    backToContacts: 'Volver a la lista de contactos',
    editGhostProfile: 'Editar perfil fantasma',
    createGhostProfile: 'Crear perfil fantasma',
    addMeetingContext: 'Añadir marco de encuentro',
    addNewProfile: 'Añadir un nuevo perfil',
    addContact: 'Añadir un contacto',
    searchContact: 'Buscar un contacto...',
    addNonExistingProfile: 'Añadir un perfil no existente',
  },
  messaging: {
    searchPlaceholder: 'Buscar un mensaje o contacto',
    groupNamePlaceholder: 'Nombre del grupo (opcional)',
    recipientPlaceholder: 'Ingresa tu destinatario...',
    messagePlaceholder: 'Escribe tu mensaje...',
    draftPending: 'Preparando tu mensaje…',
    aboutGroup: 'Acerca del grupo',
    seen: 'Visto',
    photo: '📷 Foto',
    noMessages: 'Sin mensajes',
    createNewMessage: 'Crear un nuevo mensaje',
  },
  profileEdit: {
    editMyProfile: 'Editar mi perfil',
    backToMyProfile: 'Volver a mi perfil',
    about: 'Acerca de:',
    categories: 'Categorías',
    searchCategories: 'Buscar categorías',
  },
  livingPlaceForm: {
    editTitle: 'Editar lugar de residencia',
    addTitle: 'Añadir lugar de residencia',
    place: 'Lugar',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    currently: 'Actualmente',
  },
  notesForm: {
    addNote: 'Añadir una nota',
    editNote: 'Editar la nota',
    titlePlaceholder: 'Título',
    notePlaceholder: 'Nota',
    sharedWith: 'Compartida con ',
    whoCanRead: '¿Quién puede leer esta nota?',
    onlyMe: 'Solo yo',
    onlyMeSubtitle: 'Nota personal',
    meAnd: 'Yo y {name}',
    meAndSubtitle: '{name} la verá en su app',
    dictate: 'Dictar',
    pin: 'Fijar',
    unpin: 'Desfijar',
    autoSave: 'Guardado automático',
    about: 'Sobre',
    choosePerson: 'Elegir una persona',
    change: 'Cambiar',
    seeProfile: 'Ver la ficha',
    lastExchange: 'Último intercambio:',
    noExchangeYet: 'Aún sin intercambios',
    otherNotes:
      '{count, plural, =0 {Ninguna otra nota sobre {name}} one {# nota más sobre {name}} other {# notas más sobre {name}}}',
    see: 'Ver',
    meAndThisPerson: 'Yo y esta persona',
    chooseFirst: 'Elige primero una persona',
    ghostNoApp: 'Este perfil no usa la app',
    notAddedBack: 'Esta persona aún no te ha añadido',
    savedForMeOnly: 'Esta persona aún no te ha añadido: la nota se guarda solo para ti.',
    date: 'Fecha',
    writtenOn: 'Escrita el {date}',
    todayDate: 'Hoy, {date}',
    allProfiles: 'Todos',
    allProfilesCount: 'Todos tus perfiles · {count}',
    privateCount: 'Privado · {count}',
    proCount: 'Pro · {count}',
    ghostCount: 'Fantasmas · {count}',
    noProfileFound: 'Ningún perfil encontrado',
    removePerson: 'Quitar a la persona de la nota',
    pinned: 'Fijada',
    pinnedWhere: 'Fijada · en «Para recordar» de {name}',
    pinnedTop: 'Fijada · arriba de tus notas',
    meAndSomeone: 'Yo y …',
    done: 'OK',
    changePerson: 'Cambiar de persona',
    noteWrittenOn: 'Nota escrita el {date}',
    today: 'Hoy',
  },
  recurrenceComponent: {
    everyDay: 'Todos los días',
    everyWeek: 'Todas las semanas',
    everyMonth: 'Todos los meses',
    everyYear: 'Todos los años',
    recurrence: 'Recurrencia',
    every: 'Cada',
    repeatOn: 'Repetir el',
    monthDetail: 'Detalle por mes',
    lastDayOfMonth: 'Último día del mes',
    end: 'Fin',
    never: 'Nunca',
    on: 'El',
    after: 'Después de',
    day: 'día',
    days: 'días',
    week: 'semana',
    weeks: 'semanas',
    month: 'mes',
    year: 'año',
    years: 'años',
    repetition: 'repetición',
    repetitions: 'repeticiones',
  },
  filters: {
    title: 'Filtros',
    gender: 'Sexo',
    age: 'Edad',
    min: 'Mín',
    max: 'Máx',
    ageYears: '{count} años',
    ageMin: 'Edad mínima',
    ageMax: 'Edad máxima',
    genderFemale: 'F',
    genderMale: 'M',
    genderNonBinary: 'NB',
    genderFemaleLong: 'Femenino',
    genderMaleLong: 'Masculino',
    genderNonBinaryLong: 'No binario',
    residence: 'Lugar de residencia',
    residenceContinent: 'Continente',
    residenceCountry: 'País',
    residenceRegion: 'Región',
    residenceCity: 'Ciudad',
    livedPlaces: 'Lugares vividos',
    origin: 'Origen',
    nationality: 'Nacionalidad',
    profession: 'Profesión',
    meetingContext: 'Marco del encuentro',
    associatedEmotion: 'Emoción asociada',
    relationshipEvolution: 'Evolución de la relación',
    associatedColor: 'Color asociado',
    language: 'Idioma',
    category: 'Categoría',
    hashtag: 'Hashtag',
    searchPlace: 'Buscar un lugar',
    activitySector: 'Sector de actividad',
    searchSector: 'Buscar un sector',
    searchHashtags: 'Buscar hashtags',
    searchHashtag: 'Buscar un hashtag',
    searchCategories: 'Buscar categorías',
    searchCategory: 'Buscar una categoría',
    searchMeetingContext: 'Buscar un marco de encuentro',
    searchEmotion: 'Buscar una emoción asociada',
    searchRelationship: 'Buscar una evolución de la relación',
    searchColor: 'Buscar un color asociado',
    searchLanguage: 'Buscar un idioma',
    contact: 'Contacto',
    eventDate: 'Fecha del evento',
    addPlace: 'Añadir un lugar',
    place: 'Lugar',
  },
  hashtagForm: {
    addTitle: 'Añadir un hashtag',
    editTitle: 'Editar el hashtag',
    backToList: 'Volver a la lista de hashtags',
    namePlaceholder: 'Nombre...',
  },
  deleteModal: {
    confirmMessage: '¿Estás seguro de que quieres eliminar {title}?',
    delete: 'Eliminar',
    cancel: 'Cancelar',
  },
  relationalColorForm: {
    editTitle: 'Editar color relacional',
    namePlaceholder: 'Nombre...',
  },
  addContactModal: {
    addPerson: 'Añadir {name}',
    addDefaultPerson: 'Añadir nombre de la persona',
    addPrivate: 'Añadir como Privado',
    addProfessional: 'Añadir como Profesional',
    requestSent: 'Solicitud enviada',
  },
  addHashtagModal: {
    title: 'Añadir un hashtag',
    save: 'Guardar',
  },
  addCategoryModal: {
    title: 'Añadir una categoría',
    save: 'Guardar',
  },
  menuContactsList: {
    addContacts: 'Añadir contactos',
    linkedContacts: 'Contactos vinculados',
  },
  memoriesForm: {
    addPhoto: 'Añadir una foto',
    editMemory: 'Editar recuerdo',
    addMemory: 'Añadir un recuerdo',
    memory: 'Recuerdo',
    selectMemory: 'Selecciona un recuerdo',
    description: 'Descripción:',
    identifyContacts: 'Identificar contactos:',
    identifiedContacts: 'Contactos identificados',
    publish: 'Publicar',
    sharedMemories: 'Recuerdos compartidos',
    sharedAlbums: 'Álbumes compartidos',
    deleteMemoryDescription: '¿Deseas eliminar solo esta foto o el álbum completo?',
    deletePhoto: 'Eliminar esta foto',
    deleteAlbum: 'Eliminar el álbum',
    deleteAlbumDescription: '¿Estás seguro de que deseas eliminar este álbum completo?',
  },
  albums: {
    title: 'Álbumes',
    createAlbum: 'Crear álbum',
    albumName: 'Nombre del álbum',
    albumTitle: 'Título del álbum',
    defaultTitle: 'Mi álbum',
    description: 'Descripción',
    empty: 'Sin álbumes por el momento',
    deleteConfirm: '¿Estás seguro de que quieres eliminar este álbum?',
  },
  creationStack: {
    addNote: 'Añadir una nota',
    conversation: 'Conversación',
    createEvent: 'Crear un evento',
    addReminder: 'Añadir un recordatorio',
    scheduleMessage: 'Programar mensaje',
    composeMessage: 'Redactar mensaje',
  },
  calendarAddEvent: {
    notActive: 'No activa',
    active: 'Activa',
  },
  toast: {
    success: 'Éxito',
    error: 'Error',
    info: 'Info',
    scheduledMessageDeleted: 'Mensaje programado eliminado',
    scheduledMessageCreated: 'Mensaje programado creado',
    scheduledMessageUpdated: 'Mensaje programado actualizado',
    reminderUpdated: 'Cita / Recordatorio actualizado',
    reminderDeleted: 'Cita / Recordatorio eliminado',
    reminderCreated: 'Cita / Recordatorio creado',
    eventDeleted: 'Evento eliminado',
    eventCreated: 'Evento creado',
    eventUpdated: 'Evento actualizado',
    colorUpdated: 'Color actualizado',
    contactRequestSent: 'Solicitud enviada',
    contactRequestSentMessage: 'Tu solicitud de amistad ha sido enviada.',
    contactRequestCancelled: 'Solicitud cancelada',
    scopeChanged: 'Ámbito modificado',
    categoryUpdated: 'Categoría actualizada',
    categoryCreated: 'Categoría creada',
    categoryDeleted: 'Categoría eliminada',
    noteCreated: 'Nota creada',
    noteUpdated: 'Nota actualizada',
    noteDeleted: 'Nota eliminada',
    hashtagUpdated: 'Hashtag actualizado',
    hashtagDeleted: 'Hashtag eliminado',
    hashtagCreated: 'Hashtag creado',
    memoryCreated: 'Recuerdo añadido',
    memoryUpdated: 'Recuerdo actualizado',
    memoryDeleted: 'Recuerdo eliminado',
    albumCreated: 'Álbum creado',
    albumDeleted: 'Álbum eliminado',
  },
  voiceNote: {
    error: 'Error al procesar la nota vocal',
    vocal: 'Vocal',
    successProfileUpdated: 'Perfil actualizado',
    successNoteCreated: 'Nota creada',
    successProcessed: 'Nota de voz procesada',
    micUnavailableTitle: 'Micrófono no disponible',
    micUnavailableMessage:
      'Permite el micrófono para KeepTouch en los ajustes de tu navegador o de tu teléfono y vuelve a intentarlo.',
  },
  messagesScreen: {
    private: 'Privado',
    pro: 'Pro',
    groups: 'Grupos',
    other: 'Otro',
    pinnedMessages: 'Ver mensajes fijados',
    viewNotes: 'Ver notas',
    viewMedia: 'Ver medios',
    viewMembers: 'Ver miembros',
    customizeGroup: 'Personalizar grupo',
    share: 'Compartir',
    block: 'Bloquear',
    report: 'Reportar',
    group: 'Grupo',
    members: 'Miembros',
    persons: '{count} personas',
  },
  contactsScreen: {
    personFound: 'persona encontrada',
    personsFound: 'personas encontradas',
    noContactFound: 'Ningún contacto encontrado',
    professionNotSpecified: 'Profesión no especificada',
    profilesRemainingToMerge: 'perfiles restantes por fusionar',
    profileRemainingToMerge: 'perfil restante por fusionar',
    noProfileToMerge: 'Ningún perfil por fusionar',
    mergeProfiles: 'Fusionar perfiles',
    merge: 'Fusionar',
    swipeToMerge: 'Desliza a la derecha para fusionar, a la izquierda para ignorar.',
    swipeMergeInstruction: 'Desliza a la derecha para fusionar, a la izquierda para ignorar.',
    profilesRemainingToClassify: 'perfiles restantes por clasificar',
    profileRemainingToClassify: 'perfil restante por clasificar',
    noProfileToClassify: 'Ningún perfil por clasificar',
    classifyAgain: 'Volver a clasificar todo',
    classifyProfiles: 'Clasificar perfiles',
    swipeToClassify:
      'Desliza a la derecha o izquierda para definir el contacto como pro o privado.',
    swipeClassifyInstruction:
      'Desliza a la derecha o izquierda para definir el contacto como pro o privado.',
    import: 'Importar',
    importContacts: 'Importar contactos',
    importAll: 'Importar todo',
    allContactsImported: 'Todos los contactos han sido importados',
    pleaseSyncContacts: 'Por favor sincroniza tus contactos',
    allImported: 'Todos los contactos han sido importados',
    syncContacts: 'Sincronizar mis contactos',
    selected: 'seleccionado',
    contactFound: '¡Contacto encontrado!',
    profileFound: '¡Perfil encontrado!',
    contactFoundScan: '¡Contacto encontrado!',
    profileFoundScan: '¡Perfil encontrado!',
  },
  profileScreen: {
    noLivingPlaceAdded: 'Ningún lugar de residencia añadido',
    pressToAddFirstPlace: 'Toca + para añadir tu primer lugar',
    tapToAddFirstPlace: 'Toca + para añadir tu primer lugar',
    noDataAdded: 'No hay datos añadidos',
    noAvailabilityAdded: 'No hay disponibilidad añadida',
    noContactInfoAdded: 'No hay datos de contacto añadidos',
    noHashtagAdded: 'Ningún hashtag añadido',
    backToMyProfile: 'Volver a mi perfil',
    aboutSection: 'Acerca de:',
    uploadMemory: 'Sube tu recuerdo:',
    selectMemory: 'Selecciona un recuerdo',
    taggedContacts: 'Contactos etiquetados',
    contactTagged: 'Contacto etiquetado:',
    contactsTagged: 'Contactos etiquetados:',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    currently: 'Actualmente',
    cityOrCountryName: 'Nombre de la ciudad o país',
    duration: 'Duración',
    currentlyLivingHere: 'Actualmente vivo en este lugar',
  },
  notesScreen: {
    title: 'Notas',
    sharedNote: 'Nota compartida',
    personalNote: 'Nota personal',
    shared: 'compartida',
    personal: 'personal',
    allNotes: 'Todas',
    searchPeople: 'Buscar una persona',
    searchNotes: 'Buscar en las notas',
  },
  scheduledMessagesScreen: {
    private: 'Privado',
    pro: 'Pro',
    groups: 'Grupos',
    categoriesTab: 'Categorías',
    title: 'Mensajes programados',
    results: '{count} resultados',
    scheduledFor: 'Programado para {time}',
    editing: 'Edita el mensaje abajo',
    deleteConfirm: 'este mensaje programado',
    createMessage: 'Crear un mensaje',
    loadError: 'No se han podido cargar tus mensajes programados.',
    chooseRecipient: 'Elegir un destinatario',
    typeMessage: 'Escribir un mensaje',
    deleteScheduledMessage: 'Eliminar el mensaje programado',
  },
  hashtagsScreen: {
    notFound: 'Hashtag no encontrado',
    newHashtag: 'Nuevo hashtag',
    person: '{count} persona',
    persons: '{count} personas',
    results: '{count} resultado',
    resultsPlural: '{count} resultados',
  },
  relationalColorsScreen: {
    title: 'Colores relacionales',
    notFound: 'Color asociado no encontrado',
    person: '{count} persona',
    persons: '{count} personas',
    results: '{count} resultado',
    resultsPlural: '{count} resultados',
  },
  categoriesScreen: {
    title: 'Categorías',
    addSubcategory: 'Añadir una subcategoría',
    subcategoryPhoto: 'Foto de la subcategoría',
    subcategoryPlaceholder: 'Título de la subcategoría...',
    categoryPhoto: 'Foto de la categoría',
    newCategory: 'Nueva categoría',
    categoryTitlePlaceholder: 'Título de la categoría...',
    addCategory: 'Añadir una categoría',
    addSubcategoryWithPhoto: 'Añadir una subcategoría',
    person: '{count} persona',
    persons: '{count} personas',
    backToList: 'Volver a la lista de categorías',
    categoryContacts: 'En esta categoría',
  },
  notificationsScreen: {
    toAddPeople: 'para añadir personas',
    acceptAsPro: 'Aceptar como profesional',
    acceptAsPrivate: 'Aceptar como privado',
    accept: 'Aceptar',
  },
  notifications: {
    friendRequest: 'Solicitud de contacto',
    acceptedRequest: 'Solicitud aceptada',
    rejectedRequest: 'Solicitud rechazada',
    upcomingEvent: 'Evento próximo',
    contactReminder: 'Recordatorio Keep in touch',
    scheduledMessage: 'Mensaje programado',
    birthday: 'Cumpleaños',
    eventReminder: 'Recordatorio de evento',
    syncContacts: 'Sincronizar mis contactos',
    toAddPeople: 'Para añadir personas',
    all: 'Todo',
    requests: 'Solicitudes',
    agenda: 'Agenda',
    accept: 'Aceptar',
    reject: 'Rechazar',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
    acceptAsPro: 'Aceptar como profesional',
    acceptAsPrivate: 'Aceptar como privado',
    orRejectRequest: 'O rechazar la solicitud',
    requestGone: 'Esta solicitud ya no está disponible.',
    sentRequests: 'Solicitudes enviadas',
    receivedRequests: 'Solicitudes recibidas',
    sections: {
      today: 'Hoy',
      tomorrow: 'Mañana',
      thisWeek: 'Esta semana',
      earlier: 'Antes',
    },
    empty: {
      title: 'Estás al día',
      subtitle: 'No tienes ninguna notificación por ahora.',
    },
    loadError: {
      title: 'No se han podido cargar tus notificaciones',
      subtitle: 'Comprueba tu conexión e inténtalo de nuevo.',
      retry: 'Reintentar',
      stale: 'Puede que esta lista no esté actualizada.',
    },
    markAllRead: 'Marcar todo como leído',
    markAllReadShort: 'Todo leído',
    ago: 'hace {time}',
    justNow: 'ahora mismo',
    titles: {
      keepContact: 'Mantén el contacto con {name}',
      request: '{name} quiere añadirte a sus contactos',
      birthdayAge: '{name} cumple {age} años hoy',
      birthday: 'Hoy es el cumpleaños de {name}',
      scheduledMessage: 'Mensaje programado para {name}',
      event: 'Cita',
      birthdayTomorrowAge: 'Mañana, {name} cumple {age} años',
      birthdayTomorrow: 'Mañana es el cumpleaños de {name}',
      accepted: '{name} aceptó tu solicitud de contacto',
      acceptedByMe: '{name} ya forma parte de tus contactos {scope}',
      sent: 'Tu mensaje programado se ha enviado a {name}',
      sentGroup: 'Tu mensaje programado se ha enviado al grupo {name}',
      done: '¡Anotado! Has hablado con {name}',
    },
    when: {
      today: 'Hoy',
      tomorrow: 'Mañana',
      todayAt: 'Hoy a las {time}',
      tomorrowAt: 'Mañana a las {time}',
      dayAt: '{day} a las {time}',
      late: '{count, plural, one {Con 1 día de retraso} other {Con {count} días de retraso}}',
    },
    lastMessage: 'último mensaje {ago}',
    actions: {
      write: 'Escribir',
      postpone: 'Posponer',
      wish: 'Felicitar',
      seeEvent: 'Ver la cita',
      seeProfile: 'Ver su perfil',
      seeCard: 'Ver su ficha',
      edit: 'Editar',
      acceptPrivate: 'Aceptar como privado',
      acceptPro: 'Aceptar como pro',
      reject: 'Rechazar',
      done: 'Hecho',
      undo: 'Deshacer',
      route: 'Cómo llegar',
      warnLate: 'Avisar de un retraso',
      call: 'Llamar',
      sms: 'Enviar un SMS',
      email: 'Enviar un correo',
      scheduleWish: 'Programar mis felicitaciones',
      editWish: 'Modificar mis felicitaciones',
      seeConversation: 'Ver la conversación',
    },
    postpone: {
      title: 'Recordármelo',
      tomorrow: 'Mañana',
      in3Days: 'En 3 días',
      inAWeek: 'En 1 semana',
      inAMonth: 'En 1 mes',
      pickDate: 'Elegir una fecha…',
    },
    later: {
      keepContacts: '{count, plural, one {{count} seguimiento} other {{count} seguimientos}}',
      calendarEvents: '{count, plural, one {{count} cita} other {{count} citas}}',
      scheduledMessages: '{count, plural, one {{count} mensaje programado} other {{count} mensajes programados}}',
      line: 'Previsto más tarde: {items}.',
      seeKeepContacts: 'Ver mis seguimientos',
      seeCalendar: 'Ver mis citas',
    },
    details: {
      eve: 'Prepara tus felicitaciones ahora: se enviarán mañana a las {time}.',
      eveScheduled: 'Tus felicitaciones se enviarán mañana a las {time}.',
      eveGhost: 'Ficha sin cuenta KeepTouch: acuérdate de llamarle mañana.',
      ghostPhone: 'Ficha sin cuenta KeepTouch: sin mensajes en la app, pero su número está guardado.',
      ghostNoPhone: 'Ficha sin cuenta KeepTouch.',
      acceptedScope: 'Ya estáis en contacto ({scope}).',
      acceptedNoScope: 'Ya estáis en contacto.',
      mutual: '{count, plural, one {1 contacto en común: {names}} other {{count} contactos en común: {names}}}',
      nextReminder: 'Próximo recordatorio: {day}',
      finished: 'Este seguimiento ha terminado.',
      lateMessage: 'Perdona, voy con un poco de retraso, llego en cuanto pueda.',
      warnWho: '¿A quién avisar?',
    },
    scope: {
      PRIVATE: 'Privado',
      PROFESSIONAL: 'Pro',
    },
    toasts: {
      wishScheduled: 'Felicitaciones programadas para mañana a las {time}',
      settingsSaved: 'Ajustes guardados',
    },
  },
  notificationSettings: {
    title: 'Ajustes de notificaciones',
    sectionPhone: 'Avisarme en el móvil',
    sectionQuiet: 'Menos interrupciones',
    keepContact: 'Mantener el contacto',
    birthdays: 'Cumpleaños',
    events: 'Citas',
    messages: 'Mensajes nuevos',
    requests: 'Solicitudes de contacto',
    morningDigest: 'Resumen de la mañana',
    quietHours: 'No molestar',
    digestNote:
      'Un solo resumen por la mañana («1 cumpleaños, 2 personas a las que escribir») en lugar de varias notificaciones.',
    digestDelayed: 'Con «No molestar» hasta las {hour}, el resumen llega a las {hour}.',
    quietNote: 'Por la noche, los recordatorios esperan a la mañana.',
    choices: {
      keepContact: {
        onTime: 'A la hora prevista',
        morning: 'El día previsto, a las 9:00',
        off: 'Nunca',
      },
      birthdays: {
        eveAndDay: 'La víspera y el mismo día',
        day: 'El mismo día',
        off: 'Nunca',
      },
      events: {
        '15': '15 minutos antes',
        '30': '30 minutos antes',
        '60': '1 hora antes',
        '120': '2 horas antes',
        off: 'Nunca',
      },
      live: {
        always: 'Siempre',
        exceptNight: 'Salvo por la noche',
        off: 'Nunca',
      },
      morningDigest: {
        off: 'No',
        '7': 'Cada día a las 7:00',
        '8': 'Cada día a las 8:00',
        '9': 'Cada día a las 9:00',
      },
      quietHours: {
        off: 'Desactivado',
        '21-7': 'De 21:00 a 7:00',
        '22-7': 'De 22:00 a 7:00',
        '22-8': 'De 22:00 a 8:00',
        '23-7': 'De 23:00 a 7:00',
        '23-8': 'De 23:00 a 8:00',
      },
    },
    open: 'Ajustes de notificaciones',
  },
  mapScreen: {
    title: 'Mapa',
    contactFound: '{count} contacto encontrado en esta zona',
    contactsFound: '{count} contactos encontrados en esta zona',
    contactsFoundInZone:
      '{count, plural, =0 {Ningún contacto en el mapa} one {{count} contacto en el mapa} other {{count} contactos en el mapa}}',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    zoomLevel: 'Nivel de zoom',
    me: 'Yo',
    myPosition: 'Estás aquí',
    locateMe: 'Localizarme',
    myPositionHidden: 'Estás aquí (invisible para tus contactos)',
    hideMe: 'Ocultarme en el mapa de mis contactos',
    showMe: 'Mostrarme en el mapa de mis contactos',
    nowHidden: 'Eres invisible en el mapa de tus contactos',
    nowVisible: 'Eres visible en el mapa de tus contactos',
    nowVisiblePro: 'Eres visible en el mapa de tus contactos profesionales',
    nowVisiblePrivate: 'Eres visible en el mapa de tus contactos privados',
  },
  birthdaysScreen: {
    title: 'Cumpleaños',
    upcoming: 'Próximos cumpleaños',
    private: 'Privado',
    pro: 'Pro',
    noBirthday: 'Ningún cumpleaños',
    // Wish pre-filled in the conversation when the AI can't write one.
    wish: {
      opening: '¡Feliz cumpleaños, {firstName}!',
      openingEarly: '¡Feliz cumpleaños por adelantado, {firstName}!',
      openingBelated: '¡Feliz cumpleaños atrasado, {firstName}!',
      milestone: '¡{age} años, hay que celebrarlo!',
      private: '¡Que pases un día genial! 🎂',
      privateBelated: '¡Espero que hayas pasado un día genial! 🎂',
      pro: 'Le deseo un excelente día.',
      proBelated: 'Espero que haya pasado un excelente día.',
    },
  },
  keepContactScreen: {
    private: 'Privado',
    pro: 'Pro',
  },
  qrCodeScreen: {
    shareProfile: 'Compartir perfil',
    copyLink: 'Copiar enlace',
    download: 'Descargar',
  },
  webFooter: {
    legalNotice: 'Aviso legal',
    contactUs: 'Contáctanos',
    privacyPolicy: 'Política de privacidad',
    joinUs: 'Únete a nosotros',
  },
  legalNotice: {
    editor: 'Editor',
    editorContent:
      'KeepTouch SAS\nCapital social: 10.000 €\nSede social: París, Francia\nDirector de publicación: Equipo KeepTouch',
    hosting: 'Alojamiento',
    hostingContent:
      'El sitio web lo sirve Netlify. Los servidores de la aplicación están alojados en Google Cloud (Cloud Run).',
    intellectualProperty: 'Propiedad intelectual',
    intellectualPropertyContent:
      'Todo el contenido de la aplicación KeepTouch (textos, imágenes, logotipos, iconos, software) es propiedad exclusiva de KeepTouch SAS y está protegido por las leyes francesas e internacionales de propiedad intelectual. Queda prohibida cualquier reproducción, representación o distribución sin autorización previa por escrito.',
    liability: 'Responsabilidad',
    liabilityContent:
      'KeepTouch SAS se esfuerza por proporcionar información precisa y actualizada. Sin embargo, no puede garantizar la exactitud, exhaustividad o actualidad de la información disponible en la aplicación. KeepTouch SAS no será responsable de ningún daño directo o indirecto resultante del uso de la aplicación.',
  },
  contactUs: {
    description:
      '¿Tienes una pregunta, una sugerencia o necesitas ayuda? No dudes en contactarnos. Nuestro equipo te responderá lo antes posible.',
    emailLabel: 'Correo electrónico',
    email: 'contact@keeptouch.app',
    addressLabel: 'Dirección',
    address: 'KeepTouch SAS\nParís, Francia',
  },
  privacyPolicy: {
    introduction:
      'KeepTouch se compromete a proteger la privacidad y los datos personales de sus usuarios. Esta política de privacidad describe cómo recopilamos, utilizamos y protegemos su información.',
    dataCollection: 'Recopilación de datos',
    dataCollectionContent:
      'Recopilamos los datos que usted proporciona voluntariamente al crear su cuenta y al utilizar la aplicación: nombre, dirección de correo electrónico, contactos, notas, recordatorios y cualquier otra información que decida compartir.',
    dataUsage: 'Uso de datos',
    dataUsageContent:
      'Sus datos se utilizan exclusivamente para proporcionar y mejorar el servicio KeepTouch. No vendemos ni compartimos sus datos personales con terceros con fines de marketing.',
    dataProtection: 'Protección de datos',
    dataProtectionContent:
      'Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger sus datos personales contra el acceso, modificación, divulgación o destrucción no autorizados.',
    cookies: 'Cookies',
    cookiesContent:
      'La aplicación puede utilizar cookies y tecnologías similares para mejorar la experiencia del usuario y analizar el uso. Puede gestionar sus preferencias de cookies en cualquier momento desde su configuración.',
    rights: 'Sus derechos',
    rightsContent:
      'De acuerdo con el RGPD, usted tiene derecho a acceder, rectificar, eliminar y portar sus datos personales. También tiene derecho a limitar y oponerse al tratamiento de sus datos. Para ejercer estos derechos, contáctenos en: contact@keeptouch.app',
    // BORRADOR — sección « Eventos » pendiente de revisión por un jurista antes de pasar a producción
    // (ver docs/rgpd/points-a-valider-juriste.md en la API).
    eventsTitle: 'Eventos',
    eventsIntro:
      "Esta sección se aplica cuando se inscribe en un evento organizado con KeepTouch (enlace, código QR o invitación). KeepTouch es responsable de la lista de participantes en la aplicación. El organizador recibe una parte de estos datos para gestionar su evento y es responsable del uso que haga de ellos.",
    eventsData: 'Datos afectados',
    eventsDataContent:
      "Según cómo se inscriba: nombre, apellidos, correo electrónico, profesión y empresa (formulario); o, con LinkedIn, su nombre, su correo verificado, su foto y el idioma de su cuenta de LinkedIn (la información en bruto devuelta por LinkedIn se conserva en su perfil de KeepTouch). Si ya tiene una cuenta de KeepTouch, se utiliza su perfil (profesión, empresa, foto, enlace de LinkedIn). Además: la fecha y el modo de inscripción, su asistencia si el organizador la marca en la entrada y, en un evento de pago, el pago (importe, fecha, estado).",
    eventsPurposes: 'Para qué sirven estos datos',
    eventsPurposesContent:
      "Inscribirle y enviarle su código de acceso y la confirmación de inscripción; mostrar la lista de participantes a los demás inscritos para que cada uno pueda mantener el contacto; permitir que un participante le añada directamente a sus contactos, con el nombre del evento como lugar de encuentro; permitir al organizador gestionar su evento (lista, control de entrada, exportación); escribirle al terminar el evento (las personas que ha conocido); tramitar el pago de una entrada.",
    eventsLegalBasis: 'Por qué podemos utilizarlos',
    eventsLegalBasisContent:
      "La ejecución del servicio que solicita: su inscripción y ponerle en contacto con los demás participantes. Su inscripción supone aceptar aparecer en la lista, y puede retirarla en cualquier momento dándose de baja. El interés legítimo de KeepTouch y del organizador en gestionar el evento (lista, control de entrada, seguridad). La obligación legal de conservar los pagos por motivos contables.",
    eventsRecipients: 'Quién ve sus datos',
    eventsRecipientsContent:
      "Los demás inscritos, desde que se inscribe: su nombre, apellidos, profesión, empresa, foto y enlace de LinkedIn. Nunca su correo ni sus notas. Cualquier persona que tenga el enlace o el código QR del evento: solo los nombres y fotos de los participantes mientras la página pública esté abierta. El organizador: su nombre, profesión, empresa, correo, asistencia y, si lo hay, su pago; puede exportar la lista; nunca ve sus notas. Un participante que le añade: su ficha entra en sus contactos, sin solicitud ni notificación. Nuestros proveedores técnicos, que solo actúan según nuestras instrucciones: alojamiento, envío de correos y, cuando se active el pago en línea, un proveedor de pagos. KeepTouch no vende sus datos.",
    eventsRetention: 'Plazo de conservación',
    eventsRetentionContent:
      "La lista de participantes, las invitaciones, la asistencia marcada y el origen de los encuentros de un evento se eliminan 24 meses después del final del evento. Las personas que le han añadido a sus contactos y las que usted ha añadido a los suyos permanecen en esos contactos: cada contacto pertenece a quien lo creó. Si elimina su cuenta, desaparece de los contactos de los demás. Los pagos se conservan 10 años (obligación contable); si elimina su cuenta, permanecen sin ningún vínculo con usted. Si elimina su cuenta, sus datos de eventos se borran de inmediato, salvo los pagos. Los códigos de acceso enviados por correo se borran como máximo dos días después de caducar.",
    eventsInvitations: 'Invitaciones recibidas por correo',
    eventsInvitationsContent:
      "Cuando un organizador introduce su dirección para invitarle, KeepTouch le envía una invitación que indica quién le invita y a qué evento. El enlace « Dejar de recibir invitaciones de KeepTouch » de ese correo incluye su dirección en una lista de oposición: no recibirá más invitaciones nuestras.",
    eventsLinkedIn: 'Acceso con LinkedIn',
    eventsLinkedInContent:
      "Solo recibimos lo que LinkedIn transmite para el acceso: nombre, correo verificado, foto, idioma e identificador de LinkedIn. No publicamos nada en LinkedIn y no accedemos a sus contactos ni a su red. Puede retirar el acceso de KeepTouch desde los ajustes de su cuenta de LinkedIn.",
    eventsRights: 'Sus derechos y cómo ejercerlos',
    eventsRightsContent:
      "Acceso, rectificación, supresión, oposición, limitación y portabilidad. Puede: darse de baja de un evento desde la página del evento; modificar su perfil en la aplicación; eliminar su cuenta desde Ajustes > Eliminar mi cuenta (si su cuenta aún no tiene contraseña, cree una primero en Ajustes); rechazar las invitaciones con el enlace incluido en cada invitación; descargar gratis una copia de sus datos de eventos (inscripciones, asistencia, pagos, invitaciones recibidas, contactos añadidos desde un evento, solicitudes de organizador), en formato JSON u hoja de cálculo (CSV), desde Ajustes > Exportar mis datos de eventos. Para cualquier otra solicitud, escríbanos: respondemos en el plazo de un mes. También puede acudir a la autoridad de protección de datos (en Francia, la CNIL: cnil.fr).",
  },
  joinUs: {
    description:
      'KeepTouch es una aplicación innovadora dedicada a ayudar a las personas a mantener y fortalecer sus relaciones. ¡Únete a nuestro equipo y contribuye a un proyecto que marca la diferencia!',
    whyJoin: '¿Por qué unirse a KeepTouch?',
    whyJoinContent:
      '• Trabajar en un proyecto innovador con impacto social\n• Unirse a un equipo apasionado y dinámico\n• Entorno de trabajo flexible y compatible con el teletrabajo\n• Oportunidades de crecimiento y desarrollo',
    positions: 'Puestos abiertos',
    positionsContent:
      'Siempre estamos buscando personas talentosas para unirse a nuestro equipo. Las ofertas actuales incluyen:\n\n• Desarrollador Full-Stack (React Native / NestJS)\n• Diseñador UX/UI\n• Responsable de Marketing y Growth\n• Community Manager',
    apply: 'Cómo postularse',
    applyEmail: 'jobs@keeptouch.app',
  },
  emotionalContexts: {
    'affection-intimite': {
      name: 'Afecto e Intimidad',
      description: 'Estos contactos nutren tu corazón.',
    },
    'aspiration-inspiration': {
      name: 'Aspiración e Inspiración',
      description: 'Estos contactos te impulsan hacia arriba.',
    },
    'stimulation-aventure': {
      name: 'Estimulación y Aventura',
      description: 'Estos contactos traen movimiento y emoción a tu vida.',
    },
    'soutien-stabilite': {
      name: 'Apoyo y Estabilidad',
      description: 'Estos contactos te apoyan emocionalmente y te dan estructura.',
    },
    'reflexion-profondeur': {
      name: 'Reflexión y Profundidad',
      description: 'Estos contactos te ayudan a pensar, comprenderte y evolucionar.',
    },
    'lacher-prise-detente': {
      name: 'Soltar y Relajación',
      description: 'Estos contactos te ayudan a respirar, desconectar y existir sin presión.',
    },
    affection: 'Afecto',
    'joie-chaleureuse': 'Alegría cálida',
    'tendre-complicite': 'Tierna complicidad',
    'presence-reconfortante': 'Presencia reconfortante',
    'partage-authentique': 'Compartir auténtico',
    aspiration: 'Aspiración',
    motivation: 'Motivación',
    source: 'Fuente',
    'elan-creatif': 'Impulso creativo',
    'grandeur-ame': 'Grandeza de alma',
    stimulation: 'Estimulación',
    aventure: 'Aventura',
    exploration: 'Exploración',
    'adrenaline-partagee': 'Adrenalina compartida',
    fun: 'Diversión',
    soutien: 'Apoyo',
    encouragement: 'Ánimo',
    securite: 'Seguridad',
    apaisement: 'Alivio',
    'croissance-lente': 'Crecimiento lento',
    apprentissage: 'Aprendizaje',
    comprehension: 'Comprensión',
    miroir: 'Espejo',
    'conscience-soi': 'Autoconciencia',
    'conversations-vraies': 'Conversaciones verdaderas',
    detente: 'Relajación',
    legerete: 'Ligereza',
    'presence-sans-enjeu': 'Presencia sin presión',
    rire: 'Risa',
    instantaneite: 'Espontaneidad',
  },
  meetingContexts: {
    'ecole-universite': 'Escuela / Universidad',
    travail: 'Trabajo',
    'evenement-pro': 'Evento profesional',
    'evenement-social': 'Evento social',
    'amis-connaissance': 'Amigos / Conocidos',
    voyage: 'Viaje',
    'sport-activite': 'Deporte / Actividad',
    'en-ligne': 'En línea',
    dating: 'Citas',
    famille: 'Familia',
  },
  rrule: {
    custom: 'Personalizada',
  },
  relationshipStatus: {
    growing: 'En crecimiento',
    stable: 'Estable',
    to_reconnect: 'Para reconectar',
    fluctuating: 'Fluctuante',
    declining: 'En declive',
    ended: 'Terminado',
  },
  nearby: {
    headerTitle: 'Cerca',
    pageTitle: 'Contactos cercanos',
    perimeter10: 'Perfiles a menos de 10 km',
    perimeter50: 'Perfiles a menos de 50 km',
    perimeter100: 'Perfiles a menos de 100 km',
    perimeter10Short: 'A menos de 10 km',
    perimeter50Short: 'A menos de 50 km',
    perimeter100Short: 'A menos de 100 km',
    perimeterLabel: 'Perímetros',
    visibilityAll: 'Actualmente eres visible para todos los usuarios.',
    visibilityProfessional: 'Actualmente eres visible para tus contactos profesionales.',
    visibilityPrivate: 'Actualmente eres visible para tus contactos privados.',
    visibilityHidden: 'Actualmente no eres visible para nadie cercano.',
    visibilityAllMobile: 'Visible para todos los usuarios.',
    visibilityProfessionalMobile: 'Visible para tus contactos profesionales.',
    visibilityPrivateMobile: 'Visible para tus contactos privados.',
    visibilityHiddenMobile: 'Visible para nadie.',
    visibilityLoading: 'Cargando tu visibilidad...',
    editVisibility: 'Editar mi visibilidad',
    filterPrivate: 'Privado',
    filterPro: 'Pro',
    emptyNoResults: 'Sin resultados.',
    emptyNoContacts: 'No se encontraron contactos cercanos.',
    groupLabel: 'Perfiles a menos de {distance} km!',
    visibilityOptionAllTitle: 'Pro y Privado',
    visibilityOptionAllDescription:
      'Tu perfil es visible para todos los usuarios (profesionales y privados).',
    visibilityOptionProTitle: 'Pro',
    visibilityOptionProDescription: 'Visible solo para profesionales y empresas.',
    visibilityOptionPrivateTitle: 'Privado',
    visibilityOptionPrivateDescription: 'Visible solo para usuarios privados.',
    visibilityOptionHiddenTitle: 'No ser visible',
    visibilityOptionHiddenDescription: 'Tu perfil no aparece para nadie cercano.',
    modalTitle: 'Editar mi visibilidad',
    modalSubtitle: 'Elige quién puede ver tu perfil en KeepTouch',
    modalHint: 'Marca una o más opciones según tus necesidades.',
    updateButton: 'Actualizar visibilidad',
    scopePrivate: 'Privado',
    scopePro: 'Pro',
    noPosition:
      'Tu posición aún no se conoce. Permite la localización en este dispositivo para ver tus contactos cercanos.',
    noPositionHidden:
      'Eres invisible: tu posición no se guarda, por lo que no se puede calcular la lista.',
    loadError: 'Se produjo un error. Inténtalo de nuevo.',
    visibilityUnknown: 'No se pudo cargar tu visibilidad.',
  },
  ai: {
    assistant: 'Asistente IA',
    tabSuggest: 'Sugerir',
    tabSummarize: 'Resumir',
    tabAnalyze: 'Analizar',
    generateSuggestions: 'Generar sugerencias',
    use: 'Usar',
    summaryInProgress: 'Resumiendo...',
    analysisInProgress: 'Analizando...',
    sentiment: 'Sentimiento',
    sentimentUndetermined: 'Indeterminado',
    topics: 'Temas tratados',
    dynamics: 'Dinámica',
    keyPoints: 'Puntos clave',
    errorRetry: 'Se produjo un error. Inténtalo de nuevo.',
    instructionsPlaceholder: "Instrucciones (opcional): p. ej. 'tono formal', 'propón una cita'...",
    generatedByAi: 'Mensaje generado por la IA',
  },
  scheduledMessage: {
    create: {
      reasonQuestion: '¿Cuál es el motivo del mensaje?',
      writeManually: 'Escribirlo yo mismo',
      recipientBadge: 'Para',
      reasonBadge: 'Motivo',
      additionalDetailsPlaceholder: 'P. ej. acaba de conseguir un nuevo puesto...',
      messageForContact: 'Mensaje para {name}',
      additionalDetails: 'Detalles adicionales (opcional)',
      scheduledFor: '{date} a las {time}',
      reasons: {
        birthday: 'Cumpleaños',
        reconnect: 'Retomar el contacto',
        congratulations: 'Felicitaciones',
        thank_you: 'Agradecimiento',
        check_in: 'Saber cómo está',
        new_year: 'Año nuevo / Fiestas',
        encouragement: 'Ánimo',
        other: 'Otro',
      },
      generateWithAi: 'Generar con IA',
      generating: 'Generando...',
      regenerate: 'Regenerar',
      regenerating: 'Regenerando...',
      writeYourMessage: 'Escribe tu mensaje',
      reviewAndSend: 'Revisar y enviar',
      generateFailedTitle: 'La IA no ha podido escribir el mensaje',
      generateFailedMessage: 'Inténtalo de nuevo o escríbelo tú mismo.',
    },
    schedule: {
      programButton: 'Programar',
    },
  },
  cardScan: {
    awaitingCamera: 'Esperando la cámara...',
    allowCamera: 'Autorizar la cámara',
    retake: 'Volver a tomar',
    analyze: 'Analizar',
    dragDropPhoto: 'Arrastra y suelta aquí una foto de una tarjeta de visita',
    orClickToSelect: 'o haz clic para seleccionar un archivo',
  },
  qrCodeScan: {
    title: 'Escanear un código QR',
    headerTitle: 'Código QR',
  },
  ghostForm: {
    tagsSection: 'Etiquetas',
    pinsSection: 'Anclados',
    organizeProfile: 'Organizar el perfil',
    hashtagPlaceholder: 'Nombre del #...',
    goalPlaceholder: 'Construir una casa...',
    profileHashtagsName: 'Hashtag del perfil',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
  },
  notes: {
    empty: {
      titleShared: 'Ninguna nota "compartida"',
      titlePersonal: 'Ninguna nota "personal"',
      pressPlusToCreate: 'Pulsa + para crear tu primera nota',
      noMatch: 'Ninguna nota coincide con esta búsqueda',
    },
    loadError: {
      title: 'No se pudieron cargar las notas',
      subtitle: 'Comprueba tu conexión e inténtalo de nuevo.',
      partial: 'No se pudieron cargar todas las notas.',
    },
    sections: {
      pinned: 'Fijadas',
      today: 'Hoy',
      thisWeek: 'Esta semana',
    },
    dates: {
      today: 'Hoy',
      yesterday: 'Ayer',
    },
    sharedBy: 'Compartida por {name}',
    readOnly: 'Solo su autor puede modificarla.',
    summaryTitle: 'Lo que sé de {name}',
    summaryFootnote: 'Resumen del Asistente IA a partir de tus notas',
    toRemember: 'Para recordar:',
    historyTitle: 'Historial con {name}',
    history: {
      note: 'Nota',
      message: 'Mensaje',
      event: 'Cita',
      keepContact: 'Recordatorio',
      line: '{type} · ',
    },
    source: {
      assistant: 'Asistente IA',
      voice: 'Dictada',
    },
    dictateNote: 'Dictar una nota',
    stopRecording: 'Detener · {time}',
  },
  editCategory: {
    title: 'Editar una categoría',
    deleteConfirm: 'esta categoría',
  },
  editHashtag: {
    deleteConfirm: 'este hashtag',
  },
  editNote: {
    deleteConfirm: 'esta nota',
    saved: 'Guardado',
    saving: 'Guardando…',
    close: 'Cerrar',
    notSaved: 'No guardado',
    notSavedTitle: 'Nota no guardada',
    notSavedMessage: 'No se ha podido guardar esta nota. Comprueba tu conexión e inténtalo de nuevo.',
    retry: 'Reintentar',
    leaveWithoutSaving: 'Salir sin guardar',
    keepEditing: 'Seguir en la nota',
  },
  ghostProfileExtra: {
    amisEnCommun: 'Amigos en común',
    inContactWith: 'En contacto con {names}',
  },
  formExtra: {
    selectTime: 'Seleccionar una hora',
    yourMessage: 'Tu mensaje...',
    chooseTime: 'Elegir la hora',
    cancel: 'Cancelar',
  },
  filterHeader: {
    clear: 'Borrar',
  },
  messagesPinned: {
    label: 'Anclados',
  },
  translate: {
    toggle: 'Traducir',
    original: 'Texto original',
    lang: {
      fr: 'Francés',
      en: 'Inglés',
      es: 'Español',
    },
  },
  mergeSuggestions: {
    ghostBadge: 'Fantasma',
    realBadge: 'Contacto real',
    reason: {
      FullName: 'Mismo nombre completo',
      LastName: 'Mismo apellido',
      FirstName: 'Mismo nombre',
      Email: 'Mismo email',
      Phone: 'Mismo teléfono',
      LinkedIn: 'Mismo LinkedIn',
      Instagram: 'Mismo Instagram',
      Facebook: 'Mismo Facebook',
      Twitter: 'Mismo Twitter',
    },
    confirmTitle: '¿Fusionar estas dos fichas?',
    confirmKept: '«{ghost}» (ficha que has creado) se va a fusionar con el contacto {real}. Sus notas, recordatorios, mensajes programados, categorías, hashtags y colores pasan a {real}. Los datos escritos en la ficha (teléfono, email, cumpleaños, profesión, citas…) se guardan en una nota privada. La foto y la propia ficha se eliminan. Esta acción es definitiva.',
    confirmLost: '«{ghost}» (ficha que has creado) se va a fusionar con el contacto {real}. Sus notas, recordatorios, mensajes programados, categorías, hashtags y colores pasan a {real}. Los datos escritos en la ficha (teléfono, email, cumpleaños, foto…) se borrarán. Esta acción es definitiva.',
    confirmGhostPair: '«{ghost}» se va a fusionar con tu otra ficha «{kept}». Sus notas, recordatorios, citas, categorías, hashtags y colores pasan a la ficha que se conserva. Los datos que faltan se añaden; los que son distintos se guardan en una nota privada. La ficha duplicada se elimina. Esta acción es definitiva.',
    done: 'Fichas fusionadas',
    doneNote: 'Los datos de la ficha están en una nota sobre {name}.',
    doneGhostNote: 'Los datos distintos están en una nota sobre {name}.',
    failed: 'No se ha podido hacer la fusión. No se ha modificado nada.',
  },
  ftSocialImport: {
    title: 'Importar desde una red social',
    chooseNetwork: 'Elige una red social',
    usernameLabel: 'Nombre de usuario',
    linkedinNameLabel: 'Nombre de la persona',
    startImport: 'Iniciar la importación',
    placeholder: {
      linkedin: 'Nombre Apellido (ej: Juan García)',
      facebook: 'URL o nombre de usuario (ej: https://facebook.com/zuck)',
      twitter: 'URL o nombre de usuario (ej: https://x.com/elonmusk)',
      instagram: 'Nombre de usuario (ej: ethpas)',
      generic: 'Nombre de usuario',
    },
    launched: {
      title: 'Importación iniciada',
      message:
        'La importación se ha iniciado. Puedes seguir su progreso desde la lista de contactos.',
      networkMessage: 'La importación de {network} se ha iniciado.',
    },
    error: {
      title: 'Error',
      startFailed: 'No se pudo iniciar la importación',
      validateFailed: 'No se pudo validar la selección',
      genericError: 'Ocurrió un error',
    },
    previousImports: 'Importaciones anteriores',
    newImport: 'Nueva importación',
    inProgress: 'Importación en curso…',
    failed: 'Falló',
    alreadyAdded: 'Ya añadido',
    profilesFound: '{count, plural, one {# perfil encontrado} other {# perfiles encontrados}}',
    networkDescription: {
      linkedin: 'Escribe el nombre de la persona que buscas',
      generic: 'Escribe el nombre de usuario de {network} para importar sus seguidores',
    },
    results: {
      title: 'Resultados — {network}',
      runningHint: 'Esto puede tardar unos minutos',
      failedTitle: 'La importación falló',
      selectAll: 'Seleccionar todo',
      deselectAll: 'Deseleccionar todo',
      validate: 'Validar selección ({count})',
      successTitle: 'Éxito',
      successMessage: '{count, plural, one {# perfil importado} other {# perfiles importados}}',
      loadMore: 'Mostrar más',
      shownOf: '{shown} mostrados de {total}',
      empty: 'Ningún perfil que mostrar para esta importación.',
      partial: '{count, plural, one {Se añadió # perfil} other {Se añadieron # perfiles}} antes de este error.',
    },
  },
  notFoundPage: {
    title: 'Página no encontrada',
    message: 'Esta dirección no existe o ya no existe.',
    button: 'Volver a mis contactos',
    buttonLoggedOut: 'Volver al inicio',
  },
  // --- Events POC ---
  createPassword: {
    title: "Cree su contraseña",
    subtitle: "Para volver a entrar más tarde con su correo, sin esperar un código.",
    password: "Contraseña",
    confirm: "Confirme la contraseña",
    rule: "Mínimo {min} caracteres",
    mismatch: "Las dos contraseñas no coinciden.",
    save: "Guardar",
    later: "Más tarde",
    savedTitle: "Contraseña creada",
    savedMessage: "Ya puede iniciar sesión con su correo y esta contraseña.",
    settingsTitle: "Contraseña",
    settingsDescription: "Esta cuenta aún no tiene contraseña: entra con un código enviado por correo.",
    settingsButton: "Crear mi contraseña",
  },
  loginWithCode: {
    title: "Acceso con código",
    subtitle: "Reciba un código de 6 cifras por correo: no necesita contraseña.",
    link: "Iniciar sesión con un código recibido por correo",
    withPassword: "Iniciar sesión con contraseña",
  },
  admin: {
    title: "Administración",
    forbidden: "Este espacio está reservado a los administradores de KeepTouch.",
    denied: "Este espacio está reservado a los administradores de KeepTouch.",
    home: {
      requests: "Solicitudes de organizadores",
      requestsHint: "Validar o rechazar las cuentas que quieren organizar eventos.",
      organizers: "Organizadores",
      organizersHint: "Fijar la comisión de venta de entradas de cada organizador.",
    },
    requests: {
      title: "Solicitudes pendientes",
      empty: "No hay solicitudes pendientes",
      emptyHint: "Las nuevas solicitudes de organizadores aparecerán aquí.",
      organization: "Organización",
      message: "Mensaje",
      sentOn: "Solicitud enviada el {date}",
      approve: "Validar",
      reject: "Rechazar",
      rejectTitle: "Rechazar la solicitud",
      rejectDescription: "{name} recibirá un correo con el motivo del rechazo.",
      rejectReasonLabel: "Motivo del rechazo (obligatorio)",
      toast: {
        approved: "Organizador validado",
        rejected: "Solicitud rechazada",
      },
    },
    organizers: {
      title: "Organizadores",
      searchPlaceholder: "Buscar por nombre o correo",
      empty: "Ningún organizador encontrado",
      eventCount: "{count, plural, =0 {Ningún evento} one {# evento} other {# eventos}}",
      validatedOn: "validado el {date}",
      add: "Añadir un organizador",
      active: "Activos",
      removed: "Retirados",
      emptyRemoved: "Ningún organizador retirado",
    },
    organizer: {
      title: "Organizador",
      commissionTitle: "Comisión de venta de entradas",
      commissionLabel: "Tasa de comisión (%, de 0 a 30)",
      commissionInvalid: "Introduce un número entre 0 y 30 (ejemplo: 7,5).",
      noCommission: "Sin comisión",
      commissionSummary: "Comisión del {rate} %",
      feePaidBy: "Gastos pagados por",
      feeAttendee: "El participante",
      feeOrganizer: "El organizador",
      appliesToFuture: "Se aplica solo a los próximos pagos.",
      save: "Guardar",
      billingUnavailable: "El ajuste de la comisión no está disponible por ahora.",
      roleTitle: "Rol de organizador",
      roleHint: "Quitar el rol impide crear o gestionar eventos. Los eventos existentes se conservan.",
      removeRole: "Quitar el rol de organizador",
      removeConfirm: "Esta persona ya no podrá crear ni gestionar eventos. ¿Continuar?",
      organizationTitle: "Organización",
      organizationLabel: "Nombre de la organización",
      organizationInvalid: "Indique un nombre (mínimo 2 caracteres).",
      saveName: "Guardar el nombre",
      statsTitle: "Cifras",
      statEvents: "Eventos",
      statAttendees: "Inscritos",
      statPaid: "Total pagado",
      statCommission: "Comisión generada",
      eventsTitle: "Sus eventos",
      noEvents: "Todavía no hay eventos.",
      removedTitle: "Rol de organizador retirado",
      removedHint: "Esta persona ya no puede crear ni gestionar eventos. Sus eventos existentes se conservan.",
      reactivate: "Reactivar al organizador",
      toast: {
        saved: "Comisión guardada",
        renamed: "Nombre guardado",
        reactivated: "Organizador reactivado",
        removed: "Rol de organizador retirado",
      },
    },
    nav: {
      overview: "Resumen",
      requests: "Solicitudes",
      organizers: "Organizadores",
      events: "Eventos",
      settings: "Ajustes",
    },
    overview: {
      error: "No se pudieron cargar las cifras en este momento.",
      people: "Personas",
      organizers: "Organizadores activos",
      requests: "Solicitudes pendientes",
      requestsHint: "Por aprobar o rechazar",
      attendees: "Inscritos confirmados",
      attendeesHint: "Plazas confirmadas, gratuitas o de pago",
      checkedIn: "Presentes registrados",
      checkedInHint: "Marcados en la entrada",
      eventsTitle: "Eventos",
      upcoming: "Próximos",
      ongoing: "En curso",
      past: "Pasados",
      ticketingTitle: "Venta de entradas",
      paid: "Total pagado",
      paymentsCount: "{count, plural, =0 {Ningún pago} one {# pago} other {# pagos}}",
      commission: "Comisión de KeepTouch",
      net: "Neto abonado a los organizadores",
      netHint: "Tras la comisión",
      paidOnly: "Solo se cuentan los pagos completados.",
      nextEvents: "Próximos eventos",
      seeAllEvents: "Ver los eventos",
      noNextEvents: "No hay eventos próximos.",
      latestRequests: "Últimas solicitudes",
      seeRequests: "Ver las solicitudes",
      noRequests: "Todavía no hay solicitudes.",
      status: {
        pending: "Pendiente",
        approved: "Aprobada",
        rejected: "Rechazada",
      },
    },
    events: {
      title: "Eventos",
      searchPlaceholder: "Buscar un evento, un código o un organizador",
      phase: {
        upcoming: "Próximo",
        ongoing: "En curso",
        ended: "Terminado",
      },
      noOrganizer: "Organizador desconocido",
      attendees: "Inscritos",
      checkedIn: "Presentes",
      price: "Precio",
      free: "Gratis",
      paidTotal: "Total pagado",
      empty: "Ningún evento coincide.",
      range: "{from}–{to} de {total}",
      previous: "Anterior",
      next: "Siguiente",
      pageOf: "Página {page} de {pages}",
      period: "Periodo",
      periodFrom: "Desde",
      periodTo: "Hasta",
      periodInvalid: "La fecha de inicio debe ser anterior a la de fin.",
      preset: {
        today: "Hoy",
        week: "Esta semana",
        month: "Este mes",
        last30: "Últimos 30 días",
      },
      statusLabel: "Estado",
      status: {
        upcoming: "Próximo",
        ongoing: "En curso",
        ended: "Terminado",
      },
      pricingLabel: "Tarifa",
      pricing: {
        free: "Gratis",
        paid: "De pago",
      },
      categoryLabel: "Categoría",
      formatLabel: "Formato",
      organizerFilter: "Organizador",
      anyOrganizer: "Todos los organizadores",
      clearOrganizer: "Quitar el filtro de organizador",
      sortLabel: "Ordenar por",
      sort: {
        date: "Fecha",
        attendees: "Inscritos",
        paid: "Importe cobrado",
      },
      orderLabel: "Orden",
      order: {
        asc: "Ascendente",
        desc: "Descendente",
      },
      total: "{count, plural, =0 {Ningún evento} one {# evento} other {# eventos}}",
      clear: "Borrar los filtros",
      error: "No se pudieron cargar los eventos (compruebe el periodo).",
    },
    eventDetail: {
      title: "Evento",
      notFound: "No se encuentra este evento.",
      code: "Código",
      publicPage: "Abrir la página pública",
      figures: "Cifras",
      capacity: "Plazas",
      unlimited: "Ilimitadas",
      payments: "Pagos",
      information: "Información",
      organizer: "Organizador",
      starts: "Inicio",
      ends: "Fin",
      registrationCloses: "Cierre de inscripciones",
      format: "Formato",
      formats: {
        in_person: "Presencial",
        online: "En línea",
        hybrid: "Presencial y en línea",
      },
      place: "Lugar",
      onlineUrl: "Enlace de conexión",
      contact: "Contacto",
      createdOn: "Creado el",
    },
    settings: {
      title: "Ajustes",
      error: "No se pudieron cargar los ajustes en este momento.",
      commissionTitle: "Comisión por defecto",
      commissionHint: "Se aplica a los organizadores que no tienen un ajuste propio. Siempre puede fijar otra tasa en la ficha de un organizador.",
      serverValue: "Valor del servidor, nunca modificado.",
      ownSettingWins: "El ajuste propio de un organizador siempre tiene prioridad.",
      historyTitle: "Historial de cambios",
      historyEmpty: "Todavía no hay ningún cambio registrado.",
      changedBy: "Modificado por {name} el {date}",
      unknownAdmin: "un administrador",
      toast: {
        saved: "Ajustes guardados",
      },
    },
    add: {
      title: "Añadir un organizador",
      searchTitle: "Una cuenta existente",
      searchHint: "Busque por nombre o email entre todas las cuentas de KeepTouch.",
      searchPlaceholder: "Nombre o email",
      noAccount: "Ninguna cuenta coincide. Invite a esta persona por email más abajo.",
      alreadyOrganizer: "Ya es organizador",
      give: "Dar el rol de organizador",
      organizationLabel: "Nombre de la organización (opcional)",
      rateLabel: "Comisión en % (opcional)",
      defaultHint: "Sin ajuste, se aplica la comisión por defecto de la plataforma. Se envía un email de «cuenta de organizador activada».",
      inviteTitle: "¿Todavía no tiene cuenta?",
      inviteHint: "La persona recibe un email con un enlace para registrarse. En cuanto tenga cuenta, será organizador automáticamente.",
      emailLabel: "Dirección de email",
      emailInvalid: "Introduzca un email válido.",
      invite: "Invitar por email",
      accountExists: "Esta dirección ya tiene una cuenta de KeepTouch. Puede darle el rol directamente.",
      pendingTitle: "Invitaciones pendientes",
      pendingEmpty: "No hay invitaciones pendientes.",
      pendingRate: "comisión {rate} %",
      pendingSince: "invitada el {date} por {name}",
      pendingExpiresOn: "Expira el {date}",
      pendingExpired: "Expirada",
      cancelInvitation: "Cancelar",
      resendInvitation: "Reenviar",
      toast: {
        given: "Rol de organizador concedido",
        invited: "Invitación enviada",
        cancelled: "Invitación cancelada",
      },
    },
    request: {
      blockTitle: "¿Organizas eventos?",
      blockHint: "Solicita una cuenta de organizador para crear tus eventos e invitar a tus participantes. El equipo de KeepTouch valida cada solicitud.",
      cta: "Ser organizador",
      retry: "Hacer una nueva solicitud",
      rejected: "Solicitud rechazada: {reason}",
      pendingTitle: "Solicitud enviada, pendiente de validación",
      pendingHint: "Tu solicitud para «{name}» está en revisión. Recibirás un correo en cuanto se procese.",
      formTitle: "Ser organizador",
      formIntro: "Cuéntanos tu actividad. Revisamos tu solicitud y respondemos por correo.",
      organizationLabel: "Organización o nombre del evento",
      organizationError: "Indica el nombre de tu organización (mínimo 2 caracteres).",
      messageLabel: "Cuéntanos sobre tus eventos",
      messageError: "Describe brevemente los eventos que organizas.",
      websiteLabel: "Sitio web (opcional)",
      websiteError: "Introduce una dirección que empiece por http:// o https://.",
      send: "Enviar mi solicitud",
      toast: {
        sentTitle: "Solicitud enviada",
        sentMessage: "Te responderemos por correo.",
      },
    },
  },
  events: {
    checkin: {
      title: "Recepción",
      startTitle: "Recepción del evento",
      startHint: "Opcional. Marque a los asistentes en la entrada: quienes no pudieron venir recibirán un resumen de las personas presentes.",
      start: "Iniciar la recepción",
      counter: "{present, plural, one {presente} other {presentes}} de {total} {total, plural, one {inscrito} other {inscritos}}",
      present: "Presente",
      absent: "Ausente",
      empty: "Nadie inscrito por ahora.",
      noResult: "Ningún participante coincide.",
      scan: {
        headerTitle: "Escanear",
        instruction: "Apunte al código QR del participante (su QR personal, o el QR de su entrada).",
        manualLabel: "Pegar el contenido del QR",
        manualPlaceholder: "https://keeptouch.co/profile/…",
        manualSubmit: "Validar",
        cameraUnavailable: "Cámara no disponible. Pegue el contenido del QR abajo.",
        checkedInTitle: "{name} — presente",
        alreadyTitle: "{name} — ya marcado a las {time}",
        alreadyTitleOtherDevice: "{name} — ya marcado a las {time} por otro dispositivo",
        notRegisteredTitle: "No inscrito en este evento",
        wrongEventTitle: "Entrada de otro evento",
        invalidTitle: "QR no reconocido",
        register: "Inscribirlo",
        registering: "Inscribiendo…",
        continueScanning: "Seguir escaneando",
        registerFull: "Evento completo: no se puede inscribir en el momento.",
        registerClosed: "Las inscripciones están cerradas.",
        registerPaymentRequired: "Este evento es de pago: la persona debe pagar para inscribirse.",
        registerInvalid: "No se pudo inscribir esta cuenta.",
      },
      offline: {
        banner: "{count, plural, one {Sin conexión — # registro pendiente} other {Sin conexión — # registros pendientes}}",
        syncing: "{count, plural, one {Sincronizando… # registro pendiente} other {Sincronizando… # registros pendientes}}",
      },
    },
    menuTitle: "Eventos",
    listTitle: "Eventos",
    tabs: {
      attending: "Mis inscripciones",
      organizing: "Mis eventos",
      discover: "Descubrir",
    },
    myStats: {
      entry: "Mis estadísticas",
      title: "Mis estadísticas",
      subtitle: "Todos sus eventos, combinados.",
      events: "Eventos",
      registered: "Inscritos",
      present: "Presentes",
      attendanceRate: "Tasa de asistencia",
      contactsExchanged: "Contactos intercambiados",
      followupsSent: "Recordatorios enviados",
      emailsSent: "Emails enviados",
      collected: "Cobrado",
      commission: "Comisión KeepTouch",
      net: "Neto del organizador",
      curveTitle: "Contactos intercambiados — últimos 7 días",
      curveEmpty: "Ningún contacto intercambiado en los últimos 7 días.",
      empty: "Cree su primer evento para ver sus estadísticas.",
    },
    discover: {
      title: "Próximos eventos públicos",
      searchPlaceholder: "Buscar un evento, una ciudad, una categoría",
      searchLabel: "Buscar",
      nearMe: "Cerca de mí",
      allEvents: "Todos",
      radius: "{km} km",
      radiusLabel: "Radio",
      locCoordinates: "Eventos públicos en un radio de {km} km a tu alrededor.",
      locCity: "No conocemos tu posición exacta: mostramos los eventos de tu ciudad.",
      locUnknown: "No conocemos tu posición. Activa la ubicación en «Cerca de ti» para ver eventos cercanos. Mientras tanto, estos son todos los eventos públicos.",
      empty: "No hay próximos eventos públicos.",
      emptyHint: "Vuelve pronto, o crea el tuyo y hazlo público.",
      emptySearch: "Ningún evento coincide con tu búsqueda.",
      emptyNear: "No hay eventos públicos cerca de ti.",
      emptyNearHint: "Prueba un radio mayor, o mira todos los eventos.",
      error: "No se pudieron cargar los eventos.",
      retry: "Reintentar",
      loadMore: "Ver más eventos",
      loading: "Cargando…",
      contactsGoing: "{count, plural, one {# contacto va} other {# contactos van}}",
      distance: "a {km} km",
      registered: "Inscrito",
      online: "En línea",
      resultsCount: "{count, plural, one {# evento} other {# eventos}}",
    },
    createButton: "Crear un evento",
    emptyAttending: "Todavía no tiene ninguna inscripción.",
    emptyAttendingHint: "Escanee el código QR de un evento o abra un enlace de invitación.",
    emptyOrganizing: "Todavía no hay eventos.",
    emptyOrganizingHint: "Cree su primer evento para invitar a sus participantes.",
    phase: {
      upcoming: "Próximo",
      ongoing: "En curso",
      ended: "Terminado",
    },
    attendeesCount: "{count, plural, =0 {Ningún inscrito} one {# inscrito} other {# inscritos}}",
    attendeesCountWithCapacity: "{count} / {capacity} plazas",
    full: "Completo",
    registrationClosed: "Inscripciones cerradas",
    organizedBy: "Organizado por {name}",
    price: {
      free: "Gratis",
      paid: "De pago",
    },
    payment: {
      simulationBanner: "Simulación: ningún pago real",
      forEvent: "Pago de tu plaza en",
      pay: "Pagar {amount}",
      priceLine: "Precio de la plaza",
      feeLine: "Gastos de servicio KeepTouch",
      totalLine: "Total",
      simulateFailure: "Simular un fallo",
      cancel: "Cancelar",
      seatHeld: "Plaza reservada: quedan {time}",
      reservedHint: "Tu plaza está bloqueada mientras pagas.",
      resume: "Reanudar el pago — {price}",
      failedTitle: "El pago no se ha completado",
      failedHint: "No se te ha cobrado y tu plaza no está reservada. Puedes intentarlo de nuevo.",
      retry: "Reintentar",
      expiredTitle: "Reserva caducada",
      expiredHint: "Han pasado los 15 minutos y la plaza se ha liberado. Empieza de nuevo para reservar otra.",
      backToEvent: "Volver al evento",
      alreadyPaid: "Este pago ya está hecho.",
      notFound: "No se encuentra esta página de pago.",
      successTitle: "Pago recibido",
      successMessage: "Tu inscripción está confirmada. ¡Hasta pronto!",
    },
    access: {
      title: "Acceso denegado",
      forbidden: "No tienes acceso a este evento.",
      notFound: "No se ha encontrado este evento.",
      back: "Volver",
    },
    public: {
      filterAll: "Todos",
      filterPresent: "Estuvieron presentes",
      whoIsComing: "¿Quién viene?",
      whoCame: "Los participantes",
      teaserHint: "Inscríbase para ver el nombre, la profesión y la empresa de los participantes.",
      nobodyYet: "Todavía no hay inscripciones.",
      moreAttendees: "+ {count} más",
      notFound: "No se encuentra este evento.",
      notFoundHint: "Compruebe el enlace o el código QR.",
      manage: "Gestionar el evento",
      youOrganize: "Usted organiza este evento",
      youAreRegistered: "Inscripción confirmada",
      registeredHint: "Ya puede ver los perfiles de los demás participantes y añadirlos a sus contactos.",
      ticketTitle: "Su entrada",
      ticketHint: "Muestre este código QR en la entrada.",
      viewFullScreen: "Ver mi entrada a pantalla completa",
      leave: "Cancelar mi inscripción",
      joinOneClick: "Inscribirme con un clic",
      reserveSeat: "Reservar mi plaza — {price}",
      serviceFee: "incl. {fee} de gastos de servicio",
      leavePaidHint: "Puedes darte de baja, pero no se reembolsa nada (modo prueba).",
      leaveConfirm: "¿Darte de baja de este evento?",
      leavePaidConfirm: "No se reembolsa nada. Si vuelves a inscribirte en este evento, tu entrada pagada se reutilizará (sin segundo pago) mientras queden plazas.",
      leaveConfirmYes: "Sí, darme de baja",
      leaveConfirmNo: "Seguir inscrito",
      endedIntro: "El evento ha terminado: añada a su red a las personas que conoció.",
      you: "Usted",
    },
    myTicket: {
      title: "Mi entrada",
      presentAtDoor: "Presente este código QR en la entrada",
      brightnessHint: "Aumente el brillo de la pantalla para facilitar el escaneo.",
      unavailableTitle: "Entrada no disponible",
      unavailableHint: "Debe estar en línea para abrir su entrada por primera vez.",
      eventEnded: "El evento ha terminado.",
    },
    privacy: {
      title: "Al inscribirse, acepta aparecer en la lista de participantes.",
      before: "Desde que se inscribe, los demás inscritos ven su nombre, apellidos, profesión, empresa, foto y enlace de LinkedIn. En la página pública del evento, cualquier persona que tenga el enlace ve solo su nombre y su foto (hasta el {date}).",
      after: "Los demás participantes pueden añadirle directamente a sus contactos, sin solicitud que aceptar y sin avisarle; el nombre del evento se anota como lugar de encuentro. Su correo y sus notas nunca son visibles para los demás participantes.",
      organizer: "El organizador ve su nombre, su profesión, su correo y su asistencia, y puede exportar la lista. Nunca ve sus notas.",
      durationOne: "Esta información se elimina 1 mes después del evento. Puede darse de baja en cualquier momento.",
      durationMany: "Esta información se elimina {months} meses después del evento. Puede darse de baja en cualquier momento.",
      policy: "Política de privacidad",
    },
    join: {
      title: "Unirse al evento",
      subtitle: "Inscríbase en segundos y descubra enseguida a los demás participantes.",
      linkedin: "Continuar con LinkedIn",
      noLinkedin: "No tengo LinkedIn",
      haveAccount: "¿Ya tiene cuenta en KeepTouch?",
      signIn: "Iniciar sesión",
      firstName: "Nombre",
      lastName: "Apellido",
      jobTitle: "Profesión",
      company: "Empresa (opcional)",
      email: "Correo electrónico",
      sendCode: "Recibir mi código",
      codeSentTo: "Código enviado a {email}",
      codeLabel: "Código de 6 cifras",
      confirm: "Unirse al evento",
      resend: "Reenviar el código",
      changeEmail: "Modificar mis datos",
      back: "Volver",
      required: "Campo obligatorio",
      invalidEmail: "Correo no válido",
      fakeTitle: "Simulación de LinkedIn (modo local)",
      fakeHint: "La conexión real con LinkedIn se activará cuando exista la aplicación LinkedIn Developer.",
      fakeContinue: "Simular la conexión con LinkedIn",
      closed: "Las inscripciones están cerradas.",
      full: "El evento está completo.",
      fullHeld: "Completo: hay plazas en proceso de pago. Inténtalo de nuevo en unos minutos.",
      linkedinCallbackError: "La conexión con LinkedIn no se completó.",
      linkedinLoading: "Conectando con LinkedIn…",
      paidNotice: "Evento de pago: {price}. Pagas en el siguiente paso.",
      confirmPaid: "Continuar al pago",
    },
    completeProfile: {
      title: "Complete su perfil",
      subtitle: "Añade tu puesto para que los demás participantes te encuentren.",
      linkedinUrl: "Enlace a su perfil de LinkedIn (opcional)",
      save: "Guardar",
      later: "Más tarde",
    },
    relation: {
      add: "Añadir",
      addedTitle: "Añadido a sus contactos",
      addedMessage: "Encuéntrelo en la pestaña Pro de sus contactos. Lugar de encuentro: {event}",
      remove: "Quitar",
      removeTitle: "¿Quitar a {name} de sus contactos?",
      removeDescription: "La persona no recibirá ningún aviso.",
      contact: "En sus contactos",
      linkedin: "LinkedIn",
      meetingPlaceNote: "Lugar de encuentro guardado: {event}",
    },
    form: {
      createTitle: "Nuevo evento",
      editTitle: "Modificar el evento",
      sections: {
        info: "Información",
        dates: "Fecha y hora",
        place: "Lugar",
        registration: "Inscripciones",
        visibility: "Visibilidad",
        ticketing: "Entradas",
        cover: "Imagen de portada",
        contact: "Contacto",
      },
      name: "Nombre del evento",
      namePlaceholder: "Ej. Afterwork Tech Madrid",
      category: "Categoría",
      description: "Descripción",
      descriptionPlaceholder: "Programa, público, información práctica…",
      descriptionCounter: "{count} / {max}",
      startsAt: "Inicio",
      endsAt: "Fin",
      format: "Formato",
      location: "Nombre del lugar",
      locationPlaceholder: "Ej. Campus Madrid",
      address: "Dirección",
      addressPlaceholder: "Ej. Calle de Alcalá 1",
      city: "Ciudad",
      cityPlaceholder: "Ej. Madrid",
      onlineUrl: "Enlace de videoconferencia",
      onlineUrlPlaceholder: "https://meet.google.com/…",
      capacity: "Número de plazas",
      capacityHint: "Déjelo vacío para plazas ilimitadas.",
      visibility: "Visibilidad",
      visibilityOptions: { private: "Privado", public: "Público" },
      visibilityHint: {
        private: "Privado: el evento no aparece en ninguna parte de KeepTouch. Solo pueden inscribirse las personas a las que envíes el enlace, el código QR o una invitación.",
        public: "Público: el evento es visible para todos los usuarios de KeepTouch en «Descubrir». Ideal para atraer nuevos asistentes. El enlace y el código QR siguen funcionando.",
      },
      ticketing: "Tarifa",
      price: "Precio (en euros)",
      pricePreview: "Se mostrará: {price}",
      feeByLower: { attendee: "el participante", organizer: "el organizador" },
      commissionReadonly: "Gastos KeepTouch: {rate} % pagados por {who}.",
      commissionNone: "Sin gastos KeepTouch en este evento.",
      priceHint: "Entre {min} y {max}. Los invitados que añadas tú nunca pagan.",
      registrationClosesAt: "Fecha límite de inscripción",
      registrationClosesAtHint: "Opcional: por defecto 7 días después del fin del evento.",
      coverUpload: "Elegir una imagen",
      coverDrop: "Arrastre una imagen aquí o haga clic para elegir",
      coverDropActive: "Suelte la imagen",
      coverChange: "Cambiar",
      coverRemove: "Quitar",
      coverUploading: "Enviando la imagen…",
      coverUploadHint: "JPEG, PNG o WebP, 8 MB como máximo.",
      contactEmail: "Correo de contacto",
      contactEmailPlaceholder: "contacto@ejemplo.com",
      contactEmailHint: "Visible para los participantes para contactarle.",
      websiteUrl: "Sitio web o programa",
      websiteUrlPlaceholder: "https://",
      save: "Guardar",
      create: "Crear el evento",
      delete: "Eliminar el evento",
      deleteConfirm: "¿Eliminar definitivamente este evento y su lista de inscritos?",
      cancel: "Cancelar",
      errors: {
        name: "Dé un nombre al evento (2 caracteres como mínimo).",
        dates: "Indique una fecha de inicio y de fin válidas.",
        order: "El fin debe ser posterior al inicio.",
        capacity: "Indique un número entero entre 1 y 100 000.",
        url: "El enlace debe empezar por https://",
        email: "Indique un correo electrónico válido.",
        locationRequired: "Indique el nombre del lugar.",
        onlineUrlRequired: "Indique el enlace de la videoconferencia.",
        deadlinePast: "La fecha límite de inscripción debe estar en el futuro.",
        price: "Indica un precio entre 0,50 € y 10 000 € (p. ej. 25 o 12,50).",
        coverType: "Formato no admitido: use un JPEG, PNG o WebP.",
        coverSize: "Imagen demasiado pesada: 8 MB como máximo.",
      },
    },
    venue: {
      label: "Lugar",
      placeholder: "Buscar un lugar o una dirección",
      searching: "Buscando…",
      noResults: "Sin resultados",
      unavailable: "La búsqueda no está disponible. Escriba la dirección a mano.",
      change: "Cambiar",
      manual: "Escribir la dirección manualmente",
      backToSearch: "Buscar un lugar",
      directions: "Cómo llegar",
    },
    category: {
      networking: "Networking",
      conference: "Conferencia",
      workshop: "Taller",
      meetup: "Meetup",
      trade_show: "Feria",
      seminar: "Seminario",
      other: "Otro",
    },
    format: {
      in_person: "Presencial",
      online: "En línea",
      hybrid: "Híbrido",
    },
    details: {
      joinOnline: "Unirse en línea",
      website: "Sitio web / programa",
      contact: "Contacto",
    },
    manage: {
      back: "Mis eventos",
      edit: "Modificar",
      viewPage: "Ver la página pública",
      stats: {
        registered: "Inscritos",
        present: "Presentes",
        attendanceRate: "Tasa de asistencia",
        invitations: "Invitaciones",
        accepted: "{count} aceptadas",
        contactsExchanged: "Contactos intercambiados",
        followupsSent: "Recordatorios enviados",
        emailsSent: "Emails enviados",
        collected: "Cobrado",
        paidCount: "{count, plural, =0 {Ningún pago} one {# pago} other {# pagos}}",
        commission: "Comisión KeepTouch",
        net: "Neto del organizador",
        netHint: "Lo que recibe el organizador",
        collectedShort: "{amount} cobrados · {price}",
      },
      share: {
        title: "Compartir",
        hint: "Cualquier persona con este enlace o que escanee este código QR puede inscribirse.",
        copy: "Copiar el enlace",
        copied: "Enlace copiado",
        downloadQr: "Descargar el código QR",
      },
      invite: {
        title: "Invitar por correo",
        hint: "Pegue direcciones de correo (separadas por comas, espacios o saltos de línea).",
        placeholder: "alice@ejemplo.com, bob@ejemplo.com…",
        detected: "{count, plural, =0 {Ninguna dirección detectada} one {# dirección detectada} other {# direcciones detectadas}}",
        fromContacts: "Elegir entre mis contactos",
        selectedContacts: "{count, plural, one {# contacto seleccionado} other {# contactos seleccionados}}",
        send: "Enviar las invitaciones",
        result: "{sent, plural, =0 {Ninguna invitación enviada} one {# invitación enviada} other {# invitaciones enviadas}}",
        resultRegistered: "{count} ya inscritos",
        resultOptedOut: "{count, plural, one {# dirección no quiere recibir invitaciones de KeepTouch: omitida} other {# direcciones no quieren recibir invitaciones de KeepTouch: omitidas}}",
        resultInvalid: "Direcciones ignoradas: {list}",
        pickTitle: "Invitar contactos",
        pickDone: "Validar",
        history: "Invitaciones enviadas",
        accepted: "Aceptada",
        pending: "Pendiente",
      },
      reminders: {
        title: "Recordatorios automáticos",
        hint: "Email + notificación en la app para los inscritos confirmados: la víspera hacia las 10h, y 2h antes del inicio.",
        enabled: "Activados",
        disabled: "Desactivados",
      },
      emailing: {
        title: "Emailing",
        hint: "Escriba a sus participantes antes o después del evento.",
        recipients: "Destinatarios",
        recipientsAll: "Todos los inscritos ({count})",
        recipientsPresent: "Presentes ({count})",
        recipientsAbsent: "Ausentes ({count})",
        recipientsInvited: "Invitados no inscritos ({count})",
        subject: "Asunto",
        subjectPlaceholder: "Programa de la velada",
        message: "Mensaje",
        messagePlaceholder: "Su mensaje para los participantes…",
        alsoNotification: "También como notificación en la app",
        notificationOnly: "Solo notificación (sin email) — ej. cambio de sala",
        preview: "Vista previa",
        previewEmpty: "Complete el asunto y el mensaje para ver la vista previa.",
        send: "Enviar",
        sendNotificationOnly: "Enviar la notificación",
        result: "{count, plural, =0 {Ningún destinatario} one {Enviado a # persona} other {Enviado a # personas}}",
        resultNotificationOnly: "{count, plural, =0 {Ningún destinatario} one {Notificación enviada a # persona} other {Notificación enviada a # personas}}",
        history: "Historial de envíos",
        historyEmpty: "Todavía no se ha enviado nada.",
        historyNotificationBadge: "Notificación",
        historyEmailBadge: "Email",
        historyTicketBadge: "Entrada",
        historyAlsoNotification: "+ notificación",
        historyRecipients: "{filter} · {count, plural, =0 {ningún destinatario} one {# destinatario} other {# destinatarios}}",
        filter: {
          all: "Todos los inscritos",
          present: "Presentes",
          absent: "Ausentes",
          invited: "Invitados no inscritos",
          one: "Una persona",
        },
      },
      tickets: {
        title: "Entradas",
        hint: "Reenvíe la entrada QR (por email) a sus inscritos confirmados.",
        sendAll: "Enviar a todos los inscritos ({count})",
        sending: "Enviando…",
        result: "{count, plural, =0 {Ningún destinatario} one {Entrada enviada a # persona} other {Entradas enviadas a # personas}}",
      },
      attendees: {
        title: "Participantes",
        filterAll: "Todos",
        filterPresent: "Presentes",
        filterAbsent: "Aún no han llegado",
        export: "Exportar (CSV)",
        empty: "Todavía no hay inscritos.",
        emptySearch: "Ningún participante coincide.",
        checkIn: "Marcar presente",
        checkedIn: "Presente",
        source: {
          linkedin: "LinkedIn",
          manual: "Formulario",
          account: "Cuenta KeepTouch",
        },
        joinedOn: "Inscripción el {date}",
        collected: "Total pagado: {amount} · Comisión KeepTouch: {commission} · Neto del organizador: {net} ({count, plural, =0 {ningún pago} one {# pago} other {# pagos}})",
        paid: "Pagado",
        unregistered: "Dado de baja (pagado)",
        sendTicket: "Reenviar la entrada",
        ticketSentTitle: "Entrada enviada",
        ticketSent: "La entrada se ha reenviado por email.",
      },
    },
    toast: {
      joinedTitle: "Inscripción confirmada",
      joinedMessage: "Su plaza está reservada.",
      leftTitle: "Inscripción cancelada",
      leftMessage: "Ya no participa en este evento.",
      createdTitle: "Evento creado",
      createdMessage: "Comparta el enlace o el código QR para invitar a sus participantes.",
      updatedTitle: "Evento modificado",
      updatedMessage: "Los cambios se han guardado.",
      deletedTitle: "Evento eliminado",
      deletedMessage: "El evento y sus inscripciones se han eliminado.",
      exportedTitle: "Exportación descargada",
      profileSavedTitle: "Perfil actualizado",
      profileSavedMessage: "Los demás participantes verán su profesión.",
      invitedTitle: "Invitaciones enviadas",
    },
    native: {
      pickDateTime: "Elegir fecha y hora",
      pickDate: "Elegir fecha",
      clearDate: "Borrar la fecha",
      shareQr: "Compartir el código QR",
      shareMessage: "Inscríbete en «{name}»: {url}",
    },
  },
} as const
